import React, { useEffect, useState, useContext, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "primereact/button";
import { SelectButton } from "primereact/selectbutton";
import { Toast } from "primereact/toast";
import { classNames } from "primereact/utils";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { InputMask } from "primereact/inputmask";
import { FileUpload } from "primereact/fileupload";
import { InputNumber } from "primereact/inputnumber";
import { InputSwitch } from "primereact/inputswitch";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";

import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import Loader from "../../../../Base/Components/Loader/Loader";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext"; 
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { useForm } from "../../../../Base/Hooks/useForm";
import Card from "../../../../Base/Components/Card/Card";
import AutoCompleteDropdown from "../../../../Base/Components/Form/AutoCompleteDropdown";
import { toastShow } from "../../../../Base/Services/ToastService";
import { downloadFile } from "../../../../Base/Services/ArchivosService";  
import { getCountriesList } from "../../../../Base/API/Global/Countries/CountriesRequests";
import { getPublicCurrency } from "../../../../Base/API/Global/Currency/CurrencyRequest";

import { decodeToken } from "react-jwt";
import "./Styles/Clientes.scss";

import { descargarArchivo, descargarManual, eliminarArchivo, getAccionistas, getArchivo, getClientePorId, getDirectores, getTipoPago, GuardarAccionistas, GuardarDirectores, GuardarInscripcion, sendEmailInscripcion, uploadFile } from "../../../../API/Compras/Customers/CustomerRequests";

import { InscripcionClientesLang } from "./InscripcionClientesLang";
import { getCorreosCliente } from "../../../../Base/API/IT/ListaCorreos/ListaCorreosRequest";

const InscripcionClientes = () => {
  const { config, changeTheme } = useContext(ConfigContext);
  const navigate = useNavigate();
  const { userAuth } = useContext(AuthContext);
  const params = useParams();
  const toast = useRef(null);
  const Token = params.Token;
  const lang = params.lang !== "null" ? params.lang : "es";
  const IdHonduras = 95;
  const fileUpload = useRef(null);

  const [editable, setEditable] = useState(true);
  const [tokenInfo, setTokenInfo] = useState(null);
  const [cliente, setCliente] = useState([]);
  const [idioma, setIdioma] = useState("es");
  const [loading, setLoading] = useState(false);
  const [idCustomer, setIdCustomer] = useState(null);
  const [showMessages, setShowMessages] = useState({ error: false });
  const [correos, setCorreos] = useState('');
  const [Countries, setCountries] = useState([]);
  const [habilitarCredito, setHabilitarCredito] = useState(false);
  const [tipoPagos, setTipoPagos] = useState([]);
  const [listadoAccionistas, setListadoAccionistas] = useState([]);
  const [listadoDirectores, setListadoDirectores] = useState([]);
  const [showDialogFinal, setShowDialogFinal] = useState(false);
  const [listaFaltantes, setListaFaltantes] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [showDialogIncompleto, setShowDialogIncompleto] = useState(false);
  const [dialogIncompleto, setDialogIncompleto] = useState(false);
  const [dialogCompleto, setDialogCompleto] = useState(false);

  const [ArchivoSelected, setArchivoSelected] = useState(0);
  const [listadoArchivos, setListadoArchivos] = useState([]);
  const [validar, setValidar] = useState(false);
  const [listadoArchivosFactura, setListadoArchivosFactura] = useState([]);
  const [listadoArchivosPermiso, setListadoArchivosPermiso] = useState([]);
  const [listadoArchivosEscritura, setListadoArchivosEscritura] = useState([]);
  const [listadoArchivosConstancia, setListadoArchivosConstancia] = useState([]);
  const [listadoArchivosRegistro, setListadoArchivosRegistro] = useState([]);
  const [listadoArchivosEstados, setListadoArchivosEstados] = useState([]);
  const [listadoArchivoRepresentante, setListadoArchivoRepresentante] = useState([]);
  const [listadoArchivoRefComercial1, setListadoArchivoRefComercial1] = useState([]);
  const [listadoArchivoRefComercial2, setListadoArchivoRefComercial2] = useState([]);
  const [listadoArchivoRefBanc1, setListadoArchivoRefBanc1] = useState([]);
  const [listadoArchivoRefBanc2, setListadoArchivoRefBanc2] = useState([]);
  const [listadoArchivoCertificadoA, setListadoArchivoCertificadoA] = useState([]);
  const [listadoArchivoCertificadoL, setListadoArchivoCertificadoL] = useState([]);
  const [listadoArchivoFormatoInscripcion, setListadoArchivoFormatoInscripcion] = useState([]);


  const initialValues = {
    IdRegistro: -1,
  };

  const { values, handleInputChange, setValues } = useForm(initialValues);

  const handleCheckboxChange = (e) => {
    setHabilitarCredito(e.checked);
    verificarCampos(false, e.checked)
  };

  const getInfo = async (IdCustomer) => { 
    setLoading(true);
    setIdioma(lang);
    const result = await getClientePorId(IdCustomer, Token);
      console.log("DATOS CLIENTE COMPLETOS:", result);
      console.log("DATOS CLIENTE PRIMER REGISTRO:", result?.[0]);
      console.log("NombreRepresentanteLegal:", result?.[0]?.NombreRepresentanteLegal);
      console.log("CorreoRepresentanteLegal:", result?.[0]?.CorreoRepresentanteLegal);
      console.log("TelefonoRepresentante:", result?.[0]?.TelefonoRepresentante);
      console.log("ContactoCuentasPorPagar:", result?.[0]?.ContactoCuentasPorPagar);
      console.log("NombreContactoFin1:", result?.[0]?.NombreContactoFin1);
    if(result.length > 0){
      const contriesT = await getCountriesList(Token);
      setCountries(contriesT)
      const pais = contriesT?.find((x) => x.IdCountry === result[0]?.IdCountry);

      const moneda = await getPublicCurrency(Token);
      const money = moneda.find((m) => m.IdCurrency === result[0]?.IdCurrency)

      const tipoFacturaT = await getTipoPago(Token);
      setTipoPagos(tipoFacturaT);
      const factura = tipoFacturaT.find((t) => t.IdTipoPago === result[0]?.TipoFacturacion);

      const envioCorreos = await getCorreosCliente(Token)
      setCorreos(envioCorreos);

      setValues({
        ...result[0],
        IdRegistro: result[0].IdRegistro,
        Country: pais,
        TipoPagos: factura,
        Currencies: money,
        CorreoRepresentante: result[0]?.CorreoRepresentanteLegal,
      })
      // setEditable(result[0]?.esEditable)
      setEditable(result[0]?.esEditable !== undefined ? result[0]?.esEditable : true)
      setArchivoSelected(result[0]?.ZonaLibre ? 1 : 0)
      setHabilitarCredito(result[0]?.IdTipoPagoCliente === 2 ? true : false)


      const accionistasTempo = await getAccionistas(IdCustomer, Token);
      setListadoAccionistas(accionistasTempo)
  
      const directoresTempo = await getDirectores(IdCustomer, Token);
      setListadoDirectores(directoresTempo)

      const archivoRepresentante = await getArchivo(result[0]?.CodigoCliente, Token, "Representante");
      setListadoArchivoRepresentante(archivoRepresentante);

      const archivoRefComercial1 = await getArchivo(result[0]?.CodigoCliente, Token, "RefComercial1");
      setListadoArchivoRefComercial1(archivoRefComercial1);

      const archivoRefComercial2 = await getArchivo(result[0]?.CodigoCliente, Token, "RefComercial2");
      setListadoArchivoRefComercial2(archivoRefComercial2);

      const archivoRefBanc1 = await getArchivo(result[0]?.CodigoCliente, Token, "RefBanc1");
      setListadoArchivoRefBanc1(archivoRefBanc1);

      const archivoRefBanc2 = await getArchivo(result[0]?.CodigoCliente, Token, "RefBanc2");
      setListadoArchivoRefBanc2(archivoRefBanc2);

      const archivoBIC = await getArchivo(result[0]?.CodigoCliente, Token, "BIC");
      setListadoArchivos(archivoBIC);

      const archivoFact = await getArchivo(result[0]?.CodigoCliente, Token, "Factura");
      setListadoArchivosFactura(archivoFact);

      const estadosTempo = await getArchivo(result[0]?.CodigoCliente, Token, "EstadosFin");
      setListadoArchivosEstados(estadosTempo);

      const PermisoTempo = await getArchivo(result[0]?.CodigoCliente, Token, "Permiso");
      setListadoArchivosPermiso(PermisoTempo);

      const EscrituraTempo = await getArchivo(result[0]?.CodigoCliente, Token, "Escritura");
      setListadoArchivosEscritura(EscrituraTempo);
      
      const certificadoATempo = await getArchivo(result[0]?.CodigoCliente, Token, "CertificadoA");
      setListadoArchivoCertificadoA(certificadoATempo);

      const certificadoLTempo = await getArchivo(result[0]?.CodigoCliente, Token, "CertificadoL");
      setListadoArchivoCertificadoL(certificadoLTempo);

      const formatoTempo = await getArchivo(result[0]?.CodigoCliente, Token, "FormatoIns");
      setListadoArchivoFormatoInscripcion(formatoTempo);

      const registroTempo = await getArchivo(result[0]?.CodigoCliente, Token, "Registro");
      setListadoArchivosRegistro(registroTempo);

    }
    setLoading(false);
  }

  const verificarCampos = (boton = false, checked, zonaLibre = false) => {
    let errors = {};
    let isValid = true;

    // INFOREMACION GENERAL
    if (!values.CustomerName) {
      errors.CustomerName = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.RTN) {
      errors.RTN = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.Country) {
      errors.Country = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.State) {
      errors.State = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.City) {
      errors.City = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.Address) {
      errors.Address = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.Tel) {
      errors.Tel = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.Email) {
      errors.Email = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.PrincipalActividadEconomica) {
      errors.PrincipalActividadEconomica = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.TipoPagos) {
      errors.TipoPagos = true;
      errors.General = true;
      isValid = false;
    }


    // INFOREMACION REPRESENTANTE LEGAL
    if (!values.NombreRepresentanteLegal) {
      errors.NombreRepresentanteLegal = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.CorreoRepresentante) {
      errors.CorreoRepresentante = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.TelefonoRepresentante) {
      errors.TelefonoRepresentante = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.IdentificacionRepresentante) {
      errors.IdentificacionRepresentante = true;
      errors.General = true;
      isValid = false;
    }
    if (listadoArchivoRepresentante?.length <= 0) {
      errors.FileRepresentante = true;
      isValid = false;
    }


    if(checked !== undefined){
      if(checked === true){
        if(listadoAccionistas?.length <= 0){
          errors.ErrorAccionistas = true;
          errors.General = true;
          isValid = false;
        }
    
        //DIRECTORES
        if(listadoDirectores?.length <= 0){
          errors.ErrorDirectores = true;
          errors.General = true;
          isValid = false;
        }

        // INFOREMACION REFERENCIA
        if (!values.CompanyRefComercial1) {
          errors.CompanyRefComercial1 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.CompanyRefComercial2) {
          errors.CompanyRefComercial2 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.RefNombre1) {
          errors.RefNombre1 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.RefNombre2) {
          errors.RefNombre2 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.RefTelefono1) {
          errors.RefTelefono1 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.RefTelefono2) {
          errors.RefTelefono2 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.RefCorreo1) {
          errors.RefCorreo1 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.RefCorreo2) {
          errors.RefCorreo2 = true;
          errors.General = true;
          isValid = false;
        }
        if (listadoArchivoRefComercial1?.length <= 0) {
          errors.FileRefComercial1 = true;
          isValid = false;
        }
        if (listadoArchivoRefComercial2?.length <= 0) {
          errors.FileRefComercial2 = true;
          isValid = false;
        }

        
        //REFERENCIAS BANCARIAS
        if (!values.BankName1) {
          errors.BankName1 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.BankName2) {
          errors.BankName2 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.NombreRefBancaria1) {
          errors.NombreRefBancaria1 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.NombreRefBancaria2) {
          errors.NombreRefBancaria2 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.TelefonoRefBancaria1) {
          errors.TelefonoRefBancaria1 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.TelefonoRefBancaria2) {
          errors.TelefonoRefBancaria2 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.CorreoRefBancaria1) {
          errors.CorreoRefBancaria1 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.CorreoRefBancaria2) {
          errors.CorreoRefBancaria2 = true;
          errors.General = true;
          isValid = false;
        }
        if (listadoArchivoRefBanc1?.length <= 0) {
          errors.FileRefBanc1 = true;
          isValid = false;
        }
        if (listadoArchivoRefBanc2?.length <= 0) {
          errors.FileRefBanc2 = true;
          isValid = false;
        }

        if ((listadoArchivosFactura?.length <= 0 || !listadoArchivosFactura?.length)) {
          errors.FileFactura = true;
          isValid = false;
        }
        if (listadoArchivosEstados?.length <= 0) {
          errors.FileEstadosFinancieros = true;
          isValid = false;
        }
        if ((listadoArchivosEscritura?.length <= 0 || !listadoArchivosEscritura?.length)) {
          errors.FileConstitucion = true;
          isValid = false;
        }
      }else{
        setValues({
          ...values,
        })

        delete errors.ErrorDirectores;
        delete errors.FileConstitucion;
        delete errors.FileEstadosFinancieros;
        delete errors.FileFactura;
        delete errors.FileRefBanc1;
        delete errors.FileRefBanc2;
        delete errors.FileRefComercial1;
        delete errors.FileRefComercial2;
        delete errors.General;
    
      }
    }else{      
      if(habilitarCredito){
        //ACCIONISTAS
        if(listadoAccionistas?.length <= 0){
          errors.ErrorAccionistas = true;
          errors.General = true;
          isValid = false;
        }
    
        //DIRECTORES
        if(listadoDirectores?.length <= 0){
          errors.ErrorDirectores = true;
          errors.General = true;
          isValid = false;
        }

        // INFOREMACION REFERENCIA
        if (!values.CompanyRefComercial1) {
          errors.CompanyRefComercial1 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.CompanyRefComercial2) {
          errors.CompanyRefComercial2 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.RefNombre1) {
          errors.RefNombre1 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.RefNombre2) {
          errors.RefNombre2 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.RefTelefono1) {
          errors.RefTelefono1 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.RefTelefono2) {
          errors.RefTelefono2 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.RefCorreo1) {
          errors.RefCorreo1 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.RefCorreo2) {
          errors.RefCorreo2 = true;
          errors.General = true;
          isValid = false;
        }
        if (listadoArchivoRefComercial1?.length <= 0) {
          errors.FileRefComercial1 = true;
          isValid = false;
        }
        if (listadoArchivoRefComercial2?.length <= 0) {
          errors.FileRefComercial2 = true;
          isValid = false;
        }

        
        //REFERENCIAS BANCARIAS
        if (!values.BankName1) {
          errors.BankName1 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.BankName2) {
          errors.BankName2 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.NombreRefBancaria1) {
          errors.NombreRefBancaria1 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.NombreRefBancaria2) {
          errors.NombreRefBancaria2 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.TelefonoRefBancaria1) {
          errors.TelefonoRefBancaria1 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.TelefonoRefBancaria2) {
          errors.TelefonoRefBancaria2 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.CorreoRefBancaria1) {
          errors.CorreoRefBancaria1 = true;
          errors.General = true;
          isValid = false;
        }
        if (!values.CorreoRefBancaria2) {
          errors.CorreoRefBancaria2 = true;
          errors.General = true;
          isValid = false;
        }
        if (listadoArchivoRefBanc1?.length <= 0) {
          errors.FileRefBanc1 = true;
          isValid = false;
        }
        if (listadoArchivoRefBanc2?.length <= 0) {
          errors.FileRefBanc2 = true;
          isValid = false;
        }

        if ((listadoArchivosFactura?.length <= 0 || !listadoArchivosFactura?.length)) {
          errors.FileFactura = true;
          isValid = false;
        }
        if (listadoArchivosEstados?.length <= 0) {
          errors.FileEstadosFinancieros = true;
          isValid = false;
        }
        if ((listadoArchivosEscritura?.length <= 0 || !listadoArchivosEscritura?.length)) {
          errors.FileConstitucion = true;
          isValid = false;
        }

      }
    }

    if(habilitarCredito){
      //ACCIONISTAS
      if(listadoAccionistas?.length <= 0){
        errors.ErrorAccionistas = true;
        errors.General = true;
        isValid = false;
      }
  
      //DIRECTORES
      if(listadoDirectores?.length <= 0){
        errors.ErrorDirectores = true;
        errors.General = true;
        isValid = false;
      }

      // INFOREMACION REFERENCIA
      if (!values.CompanyRefComercial1) {
        errors.CompanyRefComercial1 = true;
        errors.General = true;
        isValid = false;
      }
      if (!values.CompanyRefComercial2) {
        errors.CompanyRefComercial2 = true;
        errors.General = true;
        isValid = false;
      }
      if (!values.RefNombre1) {
        errors.RefNombre1 = true;
        errors.General = true;
        isValid = false;
      }
      if (!values.RefNombre2) {
        errors.RefNombre2 = true;
        errors.General = true;
        isValid = false;
      }
      if (!values.RefTelefono1) {
        errors.RefTelefono1 = true;
        errors.General = true;
        isValid = false;
      }
      if (!values.RefTelefono2) {
        errors.RefTelefono2 = true;
        errors.General = true;
        isValid = false;
      }
      if (!values.RefCorreo1) {
        errors.RefCorreo1 = true;
        errors.General = true;
        isValid = false;
      }
      if (!values.RefCorreo2) {
        errors.RefCorreo2 = true;
        errors.General = true;
        isValid = false;
      }
      if (listadoArchivoRefComercial1?.length <= 0) {
        errors.FileRefComercial1 = true;
        isValid = false;
      }
      if (listadoArchivoRefComercial2?.length <= 0) {
        errors.FileRefComercial2 = true;
        isValid = false;
      }

      
      //REFERENCIAS BANCARIAS
      if (!values.BankName1) {
        errors.BankName1 = true;
        errors.General = true;
        isValid = false;
      }
      if (!values.BankName2) {
        errors.BankName2 = true;
        errors.General = true;
        isValid = false;
      }
      if (!values.NombreRefBancaria1) {
        errors.NombreRefBancaria1 = true;
        errors.General = true;
        isValid = false;
      }
      if (!values.NombreRefBancaria2) {
        errors.NombreRefBancaria2 = true;
        errors.General = true;
        isValid = false;
      }
      if (!values.TelefonoRefBancaria1) {
        errors.TelefonoRefBancaria1 = true;
        errors.General = true;
        isValid = false;
      }
      if (!values.TelefonoRefBancaria2) {
        errors.TelefonoRefBancaria2 = true;
        errors.General = true;
        isValid = false;
      }
      if (!values.CorreoRefBancaria1) {
        errors.CorreoRefBancaria1 = true;
        errors.General = true;
        isValid = false;
      }
      if (!values.CorreoRefBancaria2) {
        errors.CorreoRefBancaria2 = true;
        errors.General = true;
        isValid = false;
      }
      if (listadoArchivoRefBanc1?.length <= 0) {
        errors.FileRefBanc1 = true;
        isValid = false;
      }
      if (listadoArchivoRefBanc2?.length <= 0) {
        errors.FileRefBanc2 = true;
        isValid = false;
      }

      if ((listadoArchivosFactura?.length <= 0 || !listadoArchivosFactura?.length)) {
        errors.FileFactura = true;
        isValid = false;
      }
      if (listadoArchivosEstados?.length <= 0) {
        errors.FileEstadosFinancieros = true;
        isValid = false;
      }
      if ((listadoArchivosEscritura?.length <= 0 || !listadoArchivosEscritura?.length)) {
        errors.FileConstitucion = true;
        isValid = false;
      }

    }


    // INFOREMACION CUENTAS POR PAGAR
    if (!values.ContactoCuentasPorPagar) {
      errors.ContactoCuentasPorPagar = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.CorreoCuentasPorPagar) {
      errors.CorreoCuentasPorPagar = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.TelefonoCuentasPorPagar) {
      errors.TelefonoCuentasPorPagar = true;
      errors.General = true;
      isValid = false;
    }

    // INFOREMACION CONTACTO FINANZAS
    if (!values.NombreContactoFin1) {
      errors.NombreContactoFin1 = true;
      errors.General = true;
      isValid = false;
    }

    if (!values.CorreoContactoFin1) {
      errors.CorreoContactoFin1 = true;
      errors.General = true;
      isValid = false;
    }

    if (!values.TelefonoContactoFin1) {
      errors.TelefonoContactoFin1 = true;
      errors.General = true;
      isValid = false;
    }


    if (!values.Autorizacion) {
      errors.Autorizacion = true;
      isValid = false;
    }

    if ((listadoArchivos?.length <= 0 || !listadoArchivos?.length)) {
      errors.FileBIC = true;
      isValid = false;
    }
    
    if ((listadoArchivosPermiso?.length <= 0 || !listadoArchivosPermiso?.length)) {
      errors.FilePermisoOpera = true;
      isValid = false;
    }

    if(zonaLibre !== undefined){
      if(ArchivoSelected === 1){
        if (!values.NombreZonaLibre) {
          errors.NombreZonaLibre = true;
          isValid = false;
        }
        if ((listadoArchivosRegistro?.length <= 0 || !listadoArchivosRegistro?.length)) {
          errors.FileRegistroExonerado = true;
          isValid = false;
        }
      }else{
        // console.log("acaaaaaaaaaaaa")
      }
    }else{
      // console.log("else 1")
    }
    const totalPorcentaje = listadoAccionistas.reduce((acc, accionista) => acc + (accionista.PorcentajeParticipacion || 0), 0);

    if(totalPorcentaje !== 100 && (habilitarCredito || checked)){
      errors.Porcentaje = true;
    }

    setShowMessages({ ...errors, error: !isValid });


    const mensajesErrores = {
      CustomerName: "Nombre Cliente",
      RTN: "BIC: RTN/NIT/RUC/TAX ID",
      Country: "País",
      State: "Estado",
      City: "Ciudad",
      Address: "Dirección",
      Tel: "Teléfono",
      Email: "Correo electrónico",
      PrincipalActividadEconomica: "Actividad económica principal",
      TipoPagos: "Método de pago",
      NombreRepresentanteLegal: "Información del representante legal",
      CorreoRepresentante: "Correo del representante legal",
      TelefonoRepresentante: "Teléfono del representante legal",
      IdentificacionRepresentante: "Identificación del representante legal",
      FileRepresentante: "Archivo del representante legal",
      ContactoCuentasPorPagar: "Información de cuentas por pagar",
      CorreoCuentasPorPagar: "Correo de cuentas por pagar",
      TelefonoCuentasPorPagar: "Teléfono de cuentas por pagar",
      NombreContactoFin1: "Información de contacto financiero 1",
      CorreoContactoFin1: "Correo de contacto financiero 1",
      TelefonoContactoFin1: "Teléfono de contacto financiero 1",
      ErrorAccionistas: "Información de los accionistas",
      ErrorDirectores: "Información de los directores",
    
      CompanyRefComercial1: "Información de referencias comerciales 1",
      CompanyRefComercial2: "Información de referencias comerciales 2",
      RefNombre1: "Nombre de referencia comercial 1",
      RefNombre2: "Nombre de referencia comercial 2",
      RefCorreo1: "Correo de referencia comercial 1",
      RefCorreo2: "Correo de referencia comercial 2",
      RefTelefono1: "Teléfono de referencia comercial 1",
      RefTelefono2: "Teléfono de referencia comercial 2",
      FileRefComercial1: "Archivo de referencia comercial 1",
      FileRefComercial2: "Archivo de referencia comercial 2",
    
      BankName1: 'Información de referencias bancarias 1',
      BankName2: 'Información de referencias bancarias 2',
      NombreRefBancaria1: "Nombre de referencia bancaria 1",
      NombreRefBancaria2: "Nombre de referencia bancaria 2",
      TelefonoRefBancaria1: "Teléfono de referencia bancaria 1",
      TelefonoRefBancaria2: "Teléfono de referencia bancaria 2",
      CorreoRefBancaria1: "Correo de referencia bancaria 1",
      CorreoRefBancaria2: "Correo de referencia bancaria 2",
      FileRefBanc1: "Archivo de referencia bancaria 1",
      FileRefBanc2: "Archivo de referencia bancaria 2",
    
      FileBIC: "Archivo BIC: RTN/NIT/RUC/TAX ID",
      FileFactura: "Archivo de factura/orden de compra/dirección",
      FileEstadosFinancieros: "Archivo de estado financiero",
      FilePermisoOpera: "Archivo de permiso de operaciones",
      FileConstitucion: "Archivo de escritura de la constitución",
      FileRegistroExonerado: "Archivo de registro exonerado",
      General: '',
      NombreZonaLibre: 'Nombre de Zona Libre.',
      Autorizacion:'Autorización',
      Porcentaje:'La suma de porcentajes de los accionistas debe ser 100%.'
    };
    
    const mensajesErroresEN = {
      CustomerName: "Customer Name",
      RTN: "BIC: RTN/NIT/RUC/TAX ID",
      Country: "Country",
      State: "State",
      City: "City",
      Address: "Address",
      Tel: "Phone",
      Email: "Email",
      PrincipalActividadEconomica: "Main Economic Activity",
      TipoPagos: "Payment Method",
      NombreRepresentanteLegal: "Legal Representative Information",
      CorreoRepresentante: "Legal Representative Email",
      TelefonoRepresentante: "Legal Representative Phone",
      IdentificacionRepresentante: "Legal Representative ID",
      FileRepresentante: "Legal Representative File",
      ContactoCuentasPorPagar: "Accounts Payable Contact Information",
      CorreoCuentasPorPagar: "Accounts Payable Email",
      TelefonoCuentasPorPagar: "Accounts Payable Phone",
      NombreContactoFin1: "Finance Contact Information 1",
      CorreoContactoFin1: "Finance Contact Email 1",
      TelefonoContactoFin1: "Finance Contact Phone 1",
      ErrorAccionistas: "Shareholders Information",
      ErrorDirectores: "Directors Information",
    
      BankName1: 'Bank Reference Information 1',
      BankName2: 'Bank Reference Information 2',
      CompanyRefComercial1: "Commercial Reference Information 1",
      CompanyRefComercial2: "Commercial Reference Information 2",
      RefNombre1: "Commercial Reference Name 1",
      RefNombre2: "Commercial Reference Name 2",
      RefCorreo1: "Commercial Reference Email 1",
      RefCorreo2: "Commercial Reference Email 2",
      RefTelefono1: "Commercial Reference Phone 1",
      RefTelefono2: "Commercial Reference Phone 2",
      FileRefComercial1: "Commercial Reference File 1",
      FileRefComercial2: "Commercial Reference File 2",
    
      NombreRefBancaria1: "Bank Reference Name 1",
      NombreRefBancaria2: "Bank Reference Name 2",
      TelefonoRefBancaria1: "Bank Reference Phone 1",
      TelefonoRefBancaria2: "Bank Reference Phone 2",
      CorreoRefBancaria1: "Bank Reference Email 1",
      CorreoRefBancaria2: "Bank Reference Email 2",
      FileRefBanc1: "Bank Reference File 1",
      FileRefBanc2: "Bank Reference File 2",
    
      FileBIC: "BIC: RTN/NIT/RUC/TAX ID",
      FileFactura: "Invoice/Purchase Order/Address File",
      FileEstadosFinancieros: "Financial Statement File",
      FilePermisoOpera: "Operating Permit File",
      FileConstitucion: "Constitution Deed File",
      FileRegistroExonerado: "Exonerated Registration File",
      General: '',
      NombreZonaLibre: 'Free Zone Name',
      Autorizacion:'Authorization',
      Porcentaje: 'The sum of the shareholders percentages must be 100%.',
    };
  
    
    const listaFaltantes = Object.keys(errors).filter(key => errors[key]).map(key => (idioma === 'es' ? mensajesErrores[key] : mensajesErroresEN[key]) || '');
    setListaFaltantes(listaFaltantes, errors);

    if(boton){
      if (Object.keys(errors).length === 0 && isValid) {
        setShowDialog(true);
      } else {
        setShowDialogIncompleto(true);
      }
    }
  }

  
  const EnviarCorreoConfimacion = async () => {
    const cliente = {
      nombre: values.CustomerName,
      codigo: values.CodigoCliente,
    };

    const htmlContent = `
      <div>
        <h4>Notificación de Actualización de Información del Cliente</h4>
        <p>El cliente <strong>${cliente.nombre}</strong>, con Códido de Cliente <strong>${cliente.codigo}</strong> ha actualizado su información.</p>
        <p>Por favor, revise la nueva información en el sistema.</p>
        <p>*Correo generado automáticamente, por favor no responder.</p>
        <p>Saludos cordiales.</p>
      </div>
    `;

    const objeto = {
      to: correos[0]?.DestinatariosMail,
      cc: correos[0]?.CCMail,
      bcc: correos[0]?.CCoMail,
      subject: correos[0]?.Asunto,
      html: htmlContent,
    };

    const result = await sendEmailInscripcion(objeto, Token);

  };

  const guardarInscripcion = async (Incompleta = false) => { 
    setLoading(true);
    verificarCampos();

    const BIC = getArchivosBIC();
    const ArchivoBIC = await BIC.then(resultado => resultado?.length > 0 ? resultado[0] : '').catch(() => '');

    const PERM = getArchivosPermiso();
    const ArchivoPERM = await PERM.then(resultado => resultado?.length > 0 ? resultado[0] : '').catch(() => '');

    const FACT = getArchivosFactura();
    const ArchivoFACT = await FACT.then(resultado => resultado?.length > 0 ? resultado[0] : '').catch(() => '');

    const ESC = getArchivosEscritura();
    const ArchivoESC = await ESC.then(resultado => resultado?.length > 0 ? resultado[0] : '').catch(() => '');

    const REG = getArchivosRegistro();
    const ArchivoREG = await REG.then(resultado => resultado?.length > 0 ? resultado[0] : '').catch(() => '');

    const EST = getArchivosEstadosFin();
    const ArchivoEST = await EST.then(resultado => resultado?.length > 0 ? resultado[0] : '').catch(() => '');

    const REP = getArchivosRepresentante();
    const ArchivoREP = await REP.then(resultado => resultado?.length > 0 ? resultado[0] : '').catch(() => '');

    const REF1 = getArchivosRefComercial1();
    const ArchivoREF1 = await REF1.then(resultado => resultado?.length > 0 ? resultado[0] : '').catch(() => '');

    const REF2 = getArchivosRefComercial2();
    const ArchivoREF2 = await REF2.then(resultado => resultado?.length > 0 ? resultado[0] : '').catch(() => '');

    const BAN1 = getArchivosRefBanc1();
    const ArchivoBAN1 = await BAN1.then(resultado => resultado?.length > 0 ? resultado[0] : '').catch(() => '');

    const BAN2 = getArchivosRefBanc2();
    const ArchivoBAN2 = await BAN2.then(resultado => resultado?.length > 0 ? resultado[0] : '').catch(() => '');

    const CAMB = getArchivosCertificadoA();
    const ArchivoCAMB = await CAMB.then(resultado => resultado?.length > 0 ? resultado[0] : '').catch(() => '');

    const CLAB = getArchivosCertificadoL();
    const ArchivoCLAB = await CLAB.then(resultado => resultado?.length > 0 ? resultado[0] : '').catch(() => '');

    setLoading(true);


    const Datos = {
      IdRegistro: values?.IdRegistro,
      IdCustomer: values?.IdCustomer,
      RTN: values?.RTN,
      CustomerName: values?.CustomerName,
      IdCountry: values?.Country.IdCountry,
      State: values?.State,
      City: values?.City,
      Address: values?.Address,
      Tel: values?.Tel,
      Email: values?.Email,
      PrincipalActividadEconomica: values?.PrincipalActividadEconomica,
      IdTipoPagoCliente: habilitarCredito ? 2 : 1,
      TipoFacturacion: values?.TipoPagos?.IdTipoPago,
      CasaMatriz: values?.CasaMatriz,
      DireccionCasaMatriz: values?.DireccionCasaMatriz,
      NombreRepresentanteLegal: values?.NombreRepresentanteLegal,
      CorreoRepresentanteLegal: values?.CorreoRepresentante,
      ContactoCuentasPorPagar: values?.ContactoCuentasPorPagar,
      CorreoCuentasPorPagar: values?.CorreoCuentasPorPagar,
      TelefonoCuentasPorPagar: values?.TelefonoCuentasPorPagar,
      NombreContactoFin1: values?.NombreContactoFin1,
      CorreoContactoFin1: values?.CorreoContactoFin1,
      TelefonoContactoFin1: values?.TelefonoContactoFin1,
      TelefonoContactoFin2: values?.TelefonoContactoFin2,
      RefNombre1: values?.RefNombre1,
      RefCorreo1: values?.RefCorreo1,
      RefTelefono1: values?.RefTelefono1,
      RefNombre2: values?.RefNombre2,
      RefCorreo2: values?.RefCorreo2,
      RefTelefono2: values?.RefTelefono2,
      RefNombre3: values?.RefNombre3,
      RefCorreo3: values?.RefCorreo3,
      RefTelefono3: values?.RefTelefono3,
      FileBIC: ArchivoBIC,
      FileFactura: ArchivoFACT,
      FilePermisoOpera: ArchivoPERM,
      FileConstitucion: ArchivoESC,
      ZonaLibre: ArchivoSelected === 1 ? 1 : 0,
      NombreZonaLibre: ArchivoSelected === 1 ? values?.NombreZonaLibre : null,
      DireccionZonaLibre: ArchivoSelected === 1 ? values?.DireccionZonaLibre : null,
      FileRegistroExonerado: ArchivoSelected === 1 ? ArchivoREG : null,
      FileEstadosFinancieros: ArchivoEST,
      Autorizacion: values?.Autorizacion,
      IdCurrency: values?.Currencies?.IdCurrency,
      ActivosCorrientes: values?.ActivosCorrientes,
      TotalActivos: values?.TotalActivos,
      PasivosCorrientes: values?.PasivosCorrientes,
      TotalPasivos: values?.TotalPasivos,

      //REPRESENTANTE
      FileRepresentante: ArchivoREP,
      TelefonoRepresentante: values?.TelefonoRepresentante,
      IdentificacionRepresentante: values?.IdentificacionRepresentante,

      //REFERENCIAS ARCHIVOS
      CompanyRefComercial1: values?.CompanyRefComercial1,
      CompanyRefComercial2: values?.CompanyRefComercial2,
      FileRefComercial1: ArchivoREF1,
      FileRefComercial2: ArchivoREF2,

      //REFERENCIAS BANCARIAS
      BankName1: values?.BankName1,
      BankName2: values?.BankName2,
      NombreRefBancaria1: values?.NombreRefBancaria1,
      NombreRefBancaria2: values?.NombreRefBancaria2,
      TelefonoRefBancaria1: values?.TelefonoRefBancaria1,
      TelefonoRefBancaria2: values?.TelefonoRefBancaria2,
      CorreoRefBancaria1: values?.CorreoRefBancaria1,
      CorreoRefBancaria2: values?.CorreoRefBancaria2,
      FileRefBanc1: ArchivoBAN1,
      FileRefBanc2: ArchivoBAN2,
      FileCertificadoAmbiental: ArchivoCAMB,
      FileCertificadoLaboral: ArchivoCLAB,

      Incompleta: Incompleta,
      Token: Token,
    };


    const DatosAccionistas = listadoAccionistas.map(accionista => ({
      ...accionista,
      Email: accionista?.EmailAccionista,
      IdCustomer: values?.IdCustomer,
      IdTipo: 1
    }));

    const DatosDirectores = listadoDirectores.map(director => ({
      ...director,
      Email: director?.EmailDirector,
      NombreAccionista: director?.NombreDirector,
      Posicion: director?.Posicion,
      IdentificacionAccionista: director?.IdentificacionDirector,
      IdCustomer: values?.IdCustomer,
      IdTipo: 2
    }));
    
    setLoading(true)
    
    const resultado = await GuardarInscripcion(Datos, Token)

    if(habilitarCredito){
      const res = await GuardarAccionistas(DatosAccionistas, Token)
      const res2 = await GuardarDirectores(DatosDirectores, Token)
    }

    if(resultado[0]?.ESTADO === 1){
      toastShow( toast, "success", "Datos Agregados", resultado[0]?.MENSAJE);
      
      getInfo(values?.IdCustomer)
      setShowDialog(false);

      if(!Incompleta){
        EnviarCorreoConfimacion();
        if(habilitarCredito){
          setShowDialogFinal(true)
        }
        setDialogCompleto(true)
        setTimeout(() => {
          setLoading(false)
          setEditable(false);
        }, 1300);
      }else{
        setDialogIncompleto(true)
        setShowDialogIncompleto(false)
        setTimeout(() => {
          setLoading(false)
        }, 1300);
      }
    }else{
      toastShow( toast, "error", "Error", resultado[0]?.MENSAJE );
      setShowDialog(false);
      setLoading(false)
    }
  }
  
  const referencia = {
    IdRef: idCustomer,
    Codigo: values?.CodigoCliente,
    CustomerName: values?.CustomerName
  };

  // -------------------------------------------- OBTENER ARCHIVOS -------------------------------------
  const getArchivosRepresentante = async (buscar) => {
    const archivo = await getArchivo(values?.CodigoCliente, Token, "Representante");
    if(buscar){
      if(archivo?.length === 0){
        setTimeout(() => {
          getArchivosRepresentante(true)
        }, 1000);
      }
    }
    setListadoArchivoRepresentante(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };

  const getArchivosRefComercial1 = async (buscar) => {
    const archivo = await getArchivo(values?.CodigoCliente, Token, "RefComercial1");
    if(buscar){
      if(archivo?.length === 0){
        setTimeout(() => {
          getArchivosRefComercial1(true)
        }, 1000);
      }
    }
    setListadoArchivoRefComercial1(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };

  const getArchivosRefComercial2 = async (buscar) => {
    const archivo = await getArchivo(values?.CodigoCliente, Token, "RefComercial2");
    if(buscar){
      if(archivo?.length === 0){
        setTimeout(() => {
          getArchivosRefComercial2(true)
        }, 1000);
      }
    }
    setListadoArchivoRefComercial2(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };

  const getArchivosRefBanc1 = async (buscar) => {
    const archivo = await getArchivo(values?.CodigoCliente, Token, "RefBanc1");
    if(buscar){
      if(archivo?.length === 0){
        setTimeout(() => {
          getArchivosRefBanc1(true)
        }, 1000);
      }
    }
    setListadoArchivoRefBanc1(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };

  const getArchivosRefBanc2 = async (buscar) => {
    const archivo = await getArchivo(values?.CodigoCliente, Token, "RefBanc2");
    if(buscar){
      if(archivo?.length === 0){
        setTimeout(() => {
          getArchivosRefBanc2(true)
        }, 1000);
      }
    }
    setListadoArchivoRefBanc2(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };

  const getArchivosBIC = async (buscar) => {
    const archivo = await getArchivo(values?.CodigoCliente, Token, "BIC");
    if(buscar){
      if(archivo?.length === 0){
        setTimeout(() => {
          getArchivosBIC(true)
        }, 1000);
      }
    }
    setListadoArchivos(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };

  const getArchivosFactura = async (buscar) => {
    const archivo = await getArchivo(values?.CodigoCliente, Token, "Factura");
    if(buscar){
      if(archivo?.length === 0){
        setTimeout(() => {
          getArchivosFactura(true)
        }, 1000);
      }
    }
    setListadoArchivosFactura(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };
  
  const getArchivosEstadosFin = async (buscar) => {
    const archivo = await getArchivo(values?.CodigoCliente, Token, "EstadosFin");
    if(buscar){
      if(archivo?.length === 0){
        setTimeout(() => {
          getArchivosEstadosFin(true)
        }, 1000);
      }
    }
    setListadoArchivosEstados(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };

  const getArchivosPermiso = async (buscar) => {
    const archivo = await getArchivo(values?.CodigoCliente, Token, "Permiso");
    if(buscar){
      if(archivo?.length === 0){
        setTimeout(() => {
          getArchivosPermiso(true)
        }, 1000);
      }
    }
    setListadoArchivosPermiso(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };

  const getArchivosEscritura = async (buscar) => {
    const archivo = await getArchivo(values?.CodigoCliente, Token, "Escritura");
    if(buscar){
      if(archivo?.length === 0){
        setTimeout(() => {
          getArchivosEscritura(true)
        }, 1000);
      }
    }
    setListadoArchivosEscritura(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };

  const getArchivosCertificadoA = async (buscar) => {
    const archivo = await getArchivo(values?.CodigoCliente, Token, "CertificadoA");
    if(buscar){
      if(archivo?.length === 0){
        setTimeout(() => {
          getArchivosCertificadoA(true)
        }, 1000);
      }
    }
    setListadoArchivoCertificadoA(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };

  const getArchivosCertificadoL = async (buscar) => {
    const archivo = await getArchivo(values?.CodigoCliente, Token, "CertificadoL");
    if(buscar){
      if(archivo?.length === 0){
        setTimeout(() => {
          getArchivosCertificadoL(true)
        }, 1000);
      }
    }
    setListadoArchivoCertificadoL(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };

  const getArchivosFormatoIns = async (buscar) => {
    const archivo = await getArchivo(values?.CodigoCliente, Token, "FormatoIns");
    if(buscar){
      if(archivo?.length === 0){
        setTimeout(() => {
          getArchivosFormatoIns(true)
        }, 1000);
      }
    }
    setListadoArchivoFormatoInscripcion(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };

  const getArchivosRegistro = async (buscar) => {
    const archivo = await getArchivo(values?.CodigoCliente, Token, "Registro");
    if(buscar){
      if(archivo?.length === 0){
        setTimeout(() => {
          getArchivosRegistro(true)
        }, 1000);
      }
    }
    setListadoArchivosRegistro(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };

  // -------------------------------------------- SUBIR ARCHIVOS -------------------------------------

  const subirFileRepresentante = async (e) => {
    if (listadoArchivoRepresentante?.length >= 1) {
      if (toast) {
        toastShow( toast, "error", "Error", setLabel('UnArchivo') );
      }
    } else {
      const inputs = [
        {
          name: "IdRef",
          type: "text",
          value: referencia.IdRef,
        },
        {
          name: "Codigo",
          type: "text",
          value: referencia.Codigo,
        },
      ];
      uploadFile({e, inputs, toast, ref: fileUpload, url: 'Representante',Token});
    }
    getArchivosRepresentante(true);
  };

  const subirFileRefComercial1 = async (e) => {
    if (listadoArchivoRefComercial1?.length >= 1) {
      if (toast) {
        toastShow( toast, "error", "Error", setLabel('UnArchivo') );
      }
    } else {
      const inputs = [
        {
          name: "IdRef",
          type: "text",
          value: referencia.IdRef,
        },
        {
          name: "Codigo",
          type: "text",
          value: referencia.Codigo,
        },
      ];
      uploadFile({e, inputs, toast, ref: fileUpload, url: 'RefComercial1',Token});
    }
    getArchivosRefComercial1(true);
  };

  const subirFileRefComercial2 = async (e) => {
    if (listadoArchivoRefComercial2?.length >= 1) {
      if (toast) {
        toastShow( toast, "error", "Error", setLabel('UnArchivo') );
      }
    } else {
      const inputs = [
        {
          name: "IdRef",
          type: "text",
          value: referencia.IdRef,
        },
        {
          name: "Codigo",
          type: "text",
          value: referencia.Codigo,
        },
      ];
      uploadFile({e, inputs, toast, ref: fileUpload, url: 'RefComercial2',Token});
    }
    getArchivosRefComercial2(true);
  };

  const subirFileRefBanc1 = async (e) => {
    if (listadoArchivoRefBanc1?.length >= 1) {
      if (toast) {
        toastShow( toast, "error", "Error", setLabel('UnArchivo') );
      }
    } else {
      const inputs = [
        {
          name: "IdRef",
          type: "text",
          value: referencia.IdRef,
        },
        {
          name: "Codigo",
          type: "text",
          value: referencia.Codigo,
        },
      ];
      uploadFile({e, inputs, toast, ref: fileUpload, url: 'RefBanc1',Token});
    }
    getArchivosRefBanc1(true);
  };

  const subirFileRefBanc2 = async (e) => {
    if (listadoArchivoRefBanc2?.length >= 1) {
      if (toast) {
        toastShow( toast, "error", "Error", setLabel('UnArchivo') );
      }
    } else {
      const inputs = [
        {
          name: "IdRef",
          type: "text",
          value: referencia.IdRef,
        },
        {
          name: "Codigo",
          type: "text",
          value: referencia.Codigo,
        },
      ];
      uploadFile({e, inputs, toast, ref: fileUpload, url: 'RefBanc2',Token});
    }
    getArchivosRefBanc2(true);
  };

  const subirFileBIC = async (e) => {
    if (listadoArchivos?.length >= 1) {
      if (toast) {
        toastShow( toast, "error", "Error", setLabel('UnArchivo') );
      }
    } else {
      const inputs = [
        {
          name: "IdRef",
          type: "text",
          value: referencia.IdRef,
        },
        {
          name: "Codigo",
          type: "text",
          value: referencia.Codigo,
        },
      ];
      uploadFile({e, inputs, toast, ref: fileUpload, url: 'BIC',Token});
    }
    getArchivosBIC(true);
  };

  const subirFileFactura = async (e) => {
    if (listadoArchivosFactura?.length >= 1) {
      if (toast) {
        toastShow( toast, "error", "Error", setLabel('UnArchivo') );
      }
    } else {
      const inputs = [
        {
          name: "IdRef",
          type: "text",
          value: referencia.IdRef,
        },
        {
          name: "Codigo",
          type: "text",
          value: referencia.Codigo,
        },
      ];
      uploadFile({e, inputs, toast, ref: fileUpload, url: 'Factura',Token});
    }
    getArchivosFactura(true);
  };

  const subirFileEstadosFin = async (e) => {
    if (listadoArchivosEstados?.length >= 1) {
      if (toast) {
        toastShow( toast, "error", "Error", setLabel('UnArchivo') );
      }
    } else {
      const inputs = [
        {
          name: "IdRef",
          type: "text",
          value: referencia.IdRef,
        },
        {
          name: "Codigo",
          type: "text",
          value: referencia.Codigo,
        },
      ];
      uploadFile({e, inputs, toast, ref: fileUpload, url: 'EstadosFin',Token});
    }
    getArchivosEstadosFin(true);
  };

  const subirFilePermiso = async (e) => {
    if (listadoArchivosPermiso?.length >= 1) {
      if (toast) {
        toastShow( toast, "error", "Error", setLabel('UnArchivo') );
      }
    } else {
      const inputs = [
        {
          name: "IdRef",
          type: "text",
          value: referencia.IdRef,
        },
        {
          name: "Codigo",
          type: "text",
          value: referencia.Codigo,
        },
      ];
      uploadFile({e, inputs, toast, ref: fileUpload, url: 'Permiso',Token});
    }
    getArchivosPermiso(true);
  };

  const subirFileEscritura = async (e) => {
    if (listadoArchivosEscritura?.length >= 1) {
      if (toast) {
        toastShow( toast, "error", "Error", setLabel('UnArchivo') );
      }
    } else {
      const inputs = [
        {
          name: "IdRef",
          type: "text",
          value: referencia.IdRef,
        },
        {
          name: "Codigo",
          type: "text",
          value: referencia.Codigo,
        },
      ];
      uploadFile({e, inputs, toast, ref: fileUpload, url: 'Escritura',Token});
    }
    getArchivosEscritura(true);
  };

  const subirFileCertificadoA = async (e) => {
    if (listadoArchivoCertificadoA?.length >= 1) {
      if (toast) {
        toastShow( toast, "error", "Error", setLabel('UnArchivo') );
      }
    } else {
      const inputs = [
        {
          name: "IdRef",
          type: "text",
          value: referencia.IdRef,
        },
        {
          name: "Codigo",
          type: "text",
          value: referencia.Codigo,
        },
      ];
      uploadFile({e, inputs, toast, ref: fileUpload, url: 'CertificadoA',Token});
    }
    getArchivosCertificadoA(true);
  };

  const subirFileCertificadoL = async (e) => {
    if (listadoArchivoCertificadoL?.length >= 1) {
      if (toast) {
        toastShow( toast, "error", "Error", setLabel('UnArchivo') );
      }
    } else {
      const inputs = [
        {
          name: "IdRef",
          type: "text",
          value: referencia.IdRef,
        },
        {
          name: "Codigo",
          type: "text",
          value: referencia.Codigo,
        },
      ];
      uploadFile({e, inputs, toast, ref: fileUpload, url: 'CertificadoL',Token});
    }
    getArchivosCertificadoL(true);
  };

  const subirFileFormatoIns = async (e) => {
    if (listadoArchivoFormatoInscripcion?.length >= 1) {
      if (toast) {
        toastShow( toast, "error", "Error", setLabel('UnArchivo') );
      }
    } else {
      const inputs = [
        {
          name: "IdRef",
          type: "text",
          value: referencia.IdRef,
        },
        {
          name: "Codigo",
          type: "text",
          value: referencia.Codigo,
        },
      ];
      uploadFile({e, inputs, toast, ref: fileUpload, url: 'FormatoIns',Token});
    }
    getArchivosFormatoIns(true);
  };

  const subirFileRegistro = async (e) => {
    if (listadoArchivosRegistro?.length >= 1) {
      if (toast) {
        toastShow( toast, "error", "Error", setLabel('UnArchivo') );
      }
    } else {
      const inputs = [
        {
          name: "IdRef",
          type: "text",
          value: referencia.IdRef,
        },
        {
          name: "Codigo",
          type: "text",
          value: referencia.Codigo,
        },
      ];
      uploadFile({e, inputs, toast, ref: fileUpload, url: 'Registro',Token});
    }
    getArchivosRegistro(true);
  };

  // -------------------------------------------- DESCARGAR ARCHIVOS -------------------------------------
  const DescargarArchivoFun = async (nombre, url) => {
    const a = await descargarArchivo(values?.CodigoCliente, nombre, Token, url);
    downloadFile(a, nombre);
  };

  const DescargarManualIns = async (nombre) => {
    const a = await descargarManual(nombre, Token);
    downloadFile(a, nombre);
  };

  // --------------------------------ELIMINAR ARCHIVOS-------------------------------------
  const EliminarArchivoFun = async (nombre, url) => {
    const a = await eliminarArchivo(values?.CodigoCliente, nombre, Token, url);
    toastShow( toast, "success", setLabel("Eliminado"), setLabel("ArchivoEliminado"));
    if(url === 'Representante'){
      setListadoArchivoRepresentante(listadoArchivoRepresentante.filter((archivo) => archivo !== nombre));
    }else if(url === 'RefComercial1'){
      setListadoArchivoRefComercial1(listadoArchivoRefComercial1.filter((archivo) => archivo !== nombre));
    } else if(url === 'RefComercial2'){
      setListadoArchivoRefComercial2(listadoArchivoRefComercial2.filter((archivo) => archivo !== nombre));
    } else if(url === 'RefBanc1'){
      setListadoArchivoRefBanc1(listadoArchivoRefBanc1.filter((archivo) => archivo !== nombre));
    } else if(url === 'RefBanc2'){
      setListadoArchivoRefBanc2(listadoArchivoRefBanc2.filter((archivo) => archivo !== nombre));
    } else if(url === 'BIC'){
      setListadoArchivos(listadoArchivos.filter((archivo) => archivo !== nombre));
    } else if (url === 'Factura'){
      setListadoArchivosFactura(listadoArchivosFactura.filter((archivo) => archivo !== nombre));
    } else if (url === 'EstadosFin'){
      setListadoArchivosEstados(listadoArchivosEstados.filter((archivo) => archivo !== nombre));
    } else if(url === 'Permiso'){
      setListadoArchivosPermiso(listadoArchivosPermiso.filter((archivo) => archivo !== nombre));
    } else if(url === 'Escritura'){
      setListadoArchivosEscritura(listadoArchivosEscritura.filter((archivo) => archivo !== nombre));
    } else if(url === 'CertificadoA'){
      setListadoArchivoCertificadoA(listadoArchivoCertificadoA.filter((archivo) => archivo !== nombre));
    } else if(url === 'CertificadoL'){
      setListadoArchivoCertificadoL(listadoArchivoCertificadoL.filter((archivo) => archivo !== nombre));
    } else if (url === 'FormatoIns'){
      setListadoArchivoFormatoInscripcion(listadoArchivoFormatoInscripcion.filter((archivo) => archivo !== nombre));
    } else if(url === 'Registro'){
      setListadoArchivosRegistro(listadoArchivosRegistro.filter((archivo) => archivo !== nombre));
    }
  };

  //---------------------------------ACCIONISTAS Y DIRECTORES-------------------------------------

  const agregarAccionista = async () => {
    let error = false;
    
    if (!values?.NombreAccionista) {
      toastShow(toast, 'warn', 'Error', `${getLabel(InscripcionClientesLang, 'ErrNombre', idioma)}`);
      error = true;
      return;
    }
    if (!values?.IdentificacionAccionista) {
      toastShow(toast, 'warn', 'Error', `${getLabel(InscripcionClientesLang, 'ErrId', idioma)}`);
      error = true;
      return;
    }
    if (!values?.Nacionalidad) {
      toastShow(toast, 'warn', 'Error', `${getLabel(InscripcionClientesLang, 'ErrNacionalidad', idioma)}`);
      error = true;
      return;
    }
    if (!values?.PorcentajeParticipacion) {
      toastShow(toast, 'warn', 'Error', `${getLabel(InscripcionClientesLang, 'ErrParticipacion', idioma)}`);
      error = true;
      return;
    }

  
    if (!error) {
      let newRowData = [...listadoAccionistas];

      if (values.Id) {
        newRowData = newRowData.map(accionista => 
          accionista.Id === values.Id ? { ...accionista, ...values, Nacionalidad: values?.Nacionalidad.Name || values?.Nacionalidad } : accionista
        );
      } else {

        let index = -1 * parseInt((+new Date().getTime() + "").substring(9, 14));
        const newData = {
          Id: index, 
          NombreAccionista: values?.NombreAccionista,
          IdentificacionAccionista: values?.IdentificacionAccionista,
          IdCountry: values?.Nacionalidad?.Id,
          Nacionalidad: values?.Nacionalidad?.Country || values?.Nacionalidad,
          DireccionAccionista: values?.DireccionAccionista,
          PorcentajeParticipacion: values?.PorcentajeParticipacion,
          EmailAccionista: values?.EmailAccionista
        };

        newRowData.push(newData);
      }
  
      setListadoAccionistas(newRowData);
      resetAccionistas();  
    }
  };
  
  const agregarDirectores = async () => {
    let error = false;
    
    if (!values?.NombreDirector) {
      toastShow(toast, 'warn', 'Error', `${getLabel(InscripcionClientesLang, 'ErrNombre', idioma)}`);
      error = true;
      return;
    }
    if (!values?.IdentificacionDirector) {
      toastShow(toast, 'warn', 'Error', `${getLabel(InscripcionClientesLang, 'ErrId', idioma)}`);
      error = true;
      return;
    }
    if (!values?.NacionalidadDirector) {
      toastShow(toast, 'warn', 'Error', `${getLabel(InscripcionClientesLang, 'ErrNacionalidad', idioma)}`);
      error = true;
      return;
    }

    if (!values?.Posicion) {
      toastShow(toast, 'warn', 'Error', `${getLabel(InscripcionClientesLang, 'ErrPosicion', idioma)}`);
      error = true;
      return;
    }

    if (!error) {
      let newRowData = [...listadoDirectores];

      if (values.Id) {
        newRowData = newRowData.map(director => 
          director.Id === values.Id ? { ...director, ...values, Nacionalidad: values?.NacionalidadDirector.Name || values?.NacionalidadDirector} : director
        );
      } else {

        let index = -1 * parseInt((+new Date().getTime() + "").substring(9, 14));
        const newData = {
          Id: index, 
          NombreDirector: values?.NombreDirector,
          IdentificacionDirector: values?.IdentificacionDirector,
          IdCountry: values?.NacionalidadDirector?.Id,
          NacionalidadDirector: values?.NacionalidadDirector?.Country || values?.NacionalidadDirector,
          Posicion: values?.Posicion,
          EmailDirector: values?.EmailDirector
        };
  
        newRowData.push(newData);
      }
  
      setListadoDirectores(newRowData);
      resetDirectores();  
    }
  };

  const resetAccionistas = () => {
    setValues({
      ...values,
      Id: null, 
      NombreAccionista: '',
      IdentificacionAccionista: '',
      DireccionAccionista: '',
      PorcentajeParticipacion: '',
      Nacionalidad: '',
      EmailAccionista: '',
    });
  };

  const resetDirectores = () => {
    setValues({
      ...values,
      Id: null, 
      NombreDirector: '',
      IdentificacionDirector: '',
      Posicion: '',
      NacionalidadDirector: '',
      EmailDirector: ''
    });
  };

  const editarAccionista = (id) => {
    const accionistaAEditar = listadoAccionistas.find((accionista) => accionista.Id === id);

    if (accionistaAEditar) {
      setValues({
        ...values,
        Id: accionistaAEditar.Id, 
        NombreAccionista: accionistaAEditar.NombreAccionista,
        IdentificacionAccionista: accionistaAEditar.IdentificacionAccionista,
        Nacionalidad: accionistaAEditar?.Nacionalidad,
        DireccionAccionista: accionistaAEditar.DireccionAccionista,
        PorcentajeParticipacion: accionistaAEditar.PorcentajeParticipacion,
        EmailAccionista: accionistaAEditar?.EmailAccionista
      });
    }
  };

  const editarDirector = (id) => {
    const directorAEditar = listadoDirectores.find((director) => director.Id === id);
    if (directorAEditar) {
      setValues({
        ...values,
        Id: directorAEditar.Id, 
        NombreDirector: directorAEditar.NombreDirector,
        IdentificacionDirector: directorAEditar.IdentificacionDirector,
        NacionalidadDirector: directorAEditar?.NacionalidadDirector,
        Posicion: directorAEditar.Posicion,
        EmailDirector: directorAEditar?.EmailDirector
      });
    }
  };
  
  const eliminarAccionista = (accionistaId) => {
    const nuevosAccionistas = listadoAccionistas.filter(accionista => accionista.Id !== accionistaId);
    setListadoAccionistas(nuevosAccionistas);
  };

  const eliminarDirector = (accionistaId) => {
    const nuevosAccionistas = listadoDirectores.filter(director => director.Id !== accionistaId);
    setListadoDirectores(nuevosAccionistas);
  };

  const setLabel = (label) => {
    return getLabel(InscripcionClientesLang, label, idioma);
  };

  useEffect(() => {
    const decoded = decodeToken(Token);
    if (!decoded || decoded.exp < Date.now() / 1000) {
      return;
    }
    document.title = "CSM • " + setLabel("Titulo");
    const html = document.querySelector("html");
    html.setAttribute("lang", lang);
    if (decoded) {
      setTokenInfo(decoded);
      const { IdCustomer } = decoded;
      if (IdCustomer) {
        setIdCustomer(IdCustomer);
        getInfo(IdCustomer);
      }
    }
  }, []);

  useEffect(() => {
    if (validar) {
      verificarCampos();
    }
  }, [values, listadoAccionistas, listadoArchivoCertificadoA, listadoArchivoCertificadoL, listadoArchivosPermiso, listadoArchivoRefBanc1, listadoArchivoRefBanc2, 
    listadoArchivoRefComercial1, listadoArchivoRefComercial2, listadoArchivoRepresentante, listadoArchivos, listadoArchivosConstancia, listadoArchivosEscritura, 
    listadoArchivosEstados, listadoArchivosFactura, listadoArchivosRegistro
  ]);

  const footerDialog = (
    <React.Fragment>
      <Button
        label={setLabel('no')}
        icon="pi pi-times"
        onClick={() => {setShowDialogIncompleto(false)}}
      />
      <Button
        label={setLabel('guardarBorrador')}
        icon="pi pi-check"
        className="p-button-success"
        onClick={() => guardarInscripcion(true)}
      />
    </React.Fragment>
  );

  const mensajeFaltantes = (
    <div>
      <p>{setLabel('msgNoEditableIncompleta')}</p>
      <strong>{setLabel('InformacionFaltante')}:</strong>
      <div>
        <ul>
          {listaFaltantes?.map((item, index) => (
            item !== '' ? <li key={index} className="mx-4">
              <span style={{ color: 'red' }}>-</span> {item}
            </li> : null
          ))}
        </ul>
      </div>
    </div>
  );

  if (tokenInfo) {
    return (
      <div id='inscripcion'>
        <Loader loading={loading} querySelector='#inscripcion' />
        <Toast position="bottom-right" ref={toast} />

        <ConfirmDialog
          visible={showDialog}
          onHide={() => setShowDialog(false)}
          header={setLabel('msgConfirmacion')}
          message={setLabel('msgNoEditable')}
          icon="pi pi-exclamation-triangle"
          rejectClassName="p-button-secondary"
          acceptClassName="p-button-success"
          accept={() => guardarInscripcion(false)}
          reject={e => setShowDialog(false)}
          acceptLabel={setLabel('si')}
          rejectLabel={setLabel('no')}
        />

        {dialogIncompleto && (
          <Dialog
            visible={dialogIncompleto}
            onHide={() => setDialogIncompleto(false)}
            header={setLabel('InscripcionFinalizada')}
            footer={<div>      
              <Button
                label='OK'
                icon="pi pi-check"
                className="p-button-success"
                onClick={() => setDialogIncompleto(false)}
              />
            </div>}
          >
            {setLabel('msgNoEditableIncompleta')}
          </Dialog>
        )}

        {dialogCompleto && (
          <Dialog
            visible={dialogCompleto}
            onHide={() => setDialogCompleto(false)}
            header={setLabel('InscripcionFinalizada')}
            footer={<div>      
              <Button
                label='OK'
                icon="pi pi-check"
                className="p-button-success"
                onClick={() => setDialogCompleto(false)}
              />
            </div>}
          >
            {setLabel('msgCompleta')}
          </Dialog>
        )}

        {showDialogIncompleto && (
          <Dialog
            visible={showDialogIncompleto}
            onHide={() => setShowDialogIncompleto(false)}
            header={setLabel('msgConfirmacionIncompleta')}
            footer={footerDialog}
          >
            {mensajeFaltantes}
          </Dialog>
        )}

        
        <div className="ClienteInfoContainer">
          <div className="col-12">
            {/* -------------------------------------------- HEADER------------------------------------- */}
            <div className="header">
              <div className="columna">
                <div className={config.theme === "Dark" ? "texto-blanco" : ""}>
                  <h1>{setLabel("Titulo")}</h1>
                  <div className="gap-1">
                    <h3>
                      {setLabel("codigoCliente")}: <span className="font-weight-bold text-decoration-underline">{values?.CodigoCliente}</span>
                    </h3>
                  </div>
                </div>
                {config.theme === "Light" ? (
                  <img
                    src={`${process.env.REACT_APP_Logo_Primario_H}`}
                    alt="Imagen"
                    style={{ width: "300px", height: "auto" }}
                    className="logo"
                  />
                ) : (
                  <img
                    src={`${process.env.REACT_APP_Logo_Dark_H}`}
                    style={{ width: "300px", height: "auto" }}
                    alt="Imagen"
                    className="logo"
                  />
                )}
              </div>

              <div className="switchIdioma">
                <Button
                  label={setLabel("Descargar Manual")}
                  className="mx-4"
                  icon="pi pi-download"
                  onClick={(e) => DescargarManualIns(idioma === "es" ? "Manual de Inscripción de Clientes.pdf" : "Manual En Ingles de Inscripción de Clientes.pdf")}
                />

                <SelectButton
                  value={idioma}
                  options={[
                    { label: "English", value: "en" },
                    { label: "Español", value: "es" },
                  ]}
                  onChange={(e) => setIdioma(e.value ? e.value : "es")}
                />
                <div className="mx-3">
                  <Button
                    text={config.theme === "Light"}
                    icon="pi pi-sun"
                    tooltip="Light"
                    onClick={(e) => {
                      changeTheme("Light");
                    }}
                    severity={config.theme === "Light" ? "primary" : "secondary"}
                  />
                  <Button
                    text={config.theme === "Dark"}
                    icon="pi pi-moon"
                    tooltip="Dark"
                    onClick={(e) => {
                      changeTheme("Dark");
                    }}
                    severity={config.theme === "Dark" ? "primary" : "secondary"}
                  />
                </div>
              </div>
            </div>

            <div>
              {/* INFORMACION DEl CLIENTE */}
              <Card
                titulo={<h2 style={{ fontSize: "18px", fontWeight: "bold" }}> {setLabel("informacionClienteTitle")} </h2>}
                contenido={
                  <div>
                    <div className="inputsProveedorContainer">
                      {/* Nombre Comercial (Si es distinto al nombre de la casa matriz) */}
                      <div className="input-contenedor">
                        <div className="p-float-label">
                          <InputText
                            value={values.CustomerName}
                            onChange={(e) => handleInputChange(e, "CustomerName")}
                            className={classNames({ "p-invalid": showMessages?.CustomerName})}
                            disabled={!editable}
                          />
                          <label>{setLabel("NombreCliente")}</label>
                        </div>
                      </div>

                      {/* PAIS */}
                      <div>
                        <AutoCompleteDropdown
                          name={"Country"}
                          value={values.Country}
                          label={setLabel("Pais")}
                          items={Countries}
                          field={"Country"}
                          handleInputChange={handleInputChange}
                          className={classNames({ "p-invalid": showMessages?.Country})}
                          enable={editable}
                        />
                      </div>

                      {/* ESTADO*/}
                      <div className="input-contenedor">
                        <div className="p-float-label">
                          <InputText
                            value={values.State}
                            onChange={(e) => handleInputChange(e, "State")}
                            className={classNames({"p-invalid": showMessages?.State})}
                            disabled={!editable}
                          />
                          <label>{setLabel("Estado")}</label>
                        </div>
                      </div>

                      {/* CIUDAD*/}
                      <div className="input-contenedor">
                        <div className="p-float-label">
                          <InputText
                            value={values.City}
                            onChange={(e) => handleInputChange(e, "City")}
                            className={classNames({"p-invalid": showMessages?.City})}
                            disabled={!editable}
                          />
                          <label>{setLabel("Ciudad")}</label>
                        </div>
                      </div>

                      {/* Direccion Comercial */}
                      <div className="input-contenedor">
                        <div className="p-float-label">
                          <InputText
                            value={values.Address}
                            onChange={(e) => handleInputChange(e, "Address")}
                            className={classNames({"p-invalid": showMessages?.Address})}
                            disabled={!editable}
                          />
                          <label>{setLabel("Direccion")}</label>
                        </div>
                      </div>

                      {/* RTN */}
                      {values?.Country?.Id === IdHonduras ? (
                        <div className="field">
                          <span className="p-float-label p-input-icon-right">
                              <InputMask 
                                id="righticon"
                                mask="9999-9999-999999"
                                value={values?.RTN}
                                onChange={handleInputChange}
                                name={'RTN'}
                                style={{ width: '100%' }}
                                className={classNames({"p-invalid": showMessages?.RTN})}
                                disabled={!editable}
                              />
                              <label htmlFor="righticon">RTN</label>
                          </span>
                        </div>
                      ):(
                        <div className="input-contenedor">
                          <div className="p-float-label">
                            <InputText
                              value={values.RTN}
                              onChange={(e) => handleInputChange(e, "RTN")}
                              className={classNames({"p-invalid": showMessages?.RTN})}
                              disabled={!editable}
                            />
                            <label>{setLabel("NumIdentificacionTributaria")}</label>
                          </div>
                        </div>
                      )}

                      {/* Número de teléfono principal */}
                      <div className="input-contenedor">
                        <div className="p-float-label">
                          <InputText
                            value={values.Tel}
                            onChange={(e) => handleInputChange(e, "Tel")}
                            className={classNames({"p-invalid": showMessages?.Tel})}
                            disabled={!editable}
                          />
                          <label>{setLabel("TelefonoRef")}</label>
                        </div>
                      </div>

                      {/* Correo electrónico */}
                      <div className="input-contenedor">
                        <div className="p-float-label">
                          <InputText
                            value={values.Email}
                            onChange={(e) => handleInputChange(e, "Email")}
                            className={classNames({"p-invalid": showMessages?.Email})}
                            disabled={!editable}
                          />
                          <label>{setLabel("Email")}</label>
                        </div>
                      </div>

                      {/* Principal actividad económica */}
                      <div className="input-contenedor">
                        <div className="p-float-label">
                          <InputText
                            value={values.PrincipalActividadEconomica}
                            onChange={(e) => handleInputChange(e, "PrincipalActividadEconomica") }
                            className={classNames({ "p-invalid": showMessages?.PrincipalActividadEconomica})}
                            disabled={!editable}
                          />
                          <label>{setLabel("actividadEconomica")}</label>
                        </div>
                      </div>

                      {/* Tipo de Factura */}
                      <div>
                        <AutoCompleteDropdown
                          name={"TipoPagos"}
                          value={values.TipoPagos}
                          label={setLabel("TipoFacturacion")}
                          items={tipoPagos}
                          field={idioma === 'es' ? "TipoPago" : "TipoPagoEn"}
                          handleInputChange={handleInputChange}
                          className={classNames({"p-invalid": showMessages?.TipoPagos})}
                          enable={editable}
                        />
                      </div>

                      {/* Nombre de la casa matriz */}
                      <div className="input-contenedor">
                        <div className="p-float-label">
                          <InputText
                            value={values.CasaMatriz}
                            onChange={(e) => handleInputChange(e, "CasaMatriz")}
                            className={classNames({"p-invalid": showMessages?.CasaMatriz})}
                            disabled={!editable}
                          />
                          <label>{setLabel("nombreCasaMatriz")}</label>
                        </div>
                        <small>{setLabel("distCasaMatriz")}</small>
                      </div>

                      {/* Dirección de la casa matriz */}
                      <div className="input-contenedor">
                        <div className="p-float-label">
                          <InputText
                            value={values.DireccionCasaMatriz}
                            onChange={(e) => handleInputChange(e, "DireccionCasaMatriz") }
                            className={classNames({"p-invalid": showMessages?.DireccionCasaMatriz})}
                            disabled={!editable}
                          />
                          <label>{setLabel("direccionCasaMatriz")}</label>
                        </div>
                        <small>{setLabel("distDireccionComercial")}</small>
                      </div>

                      {/* Tipo de PAGO */}
                      <div className="mt-4 mx-2 d-flex align-items-center">
                        <h4 htmlFor="solicitaCredito" style={{ color: "var(--text-color)" }} className="mx-2 mt-2">{setLabel("SolicitaCredito")}</h4>
                        <Checkbox
                          inputId="solicitaCredito"
                          checked={habilitarCredito}
                          onChange={handleCheckboxChange}
                          disabled={!editable}
                        />
                      </div>

                    </div>
                  </div>
                }
              />

              {/* INFORMACION DE CONTACTO REPRESENTANTE LEGAL */}
              <Card
                titulo={<h2 style={{ fontSize: "18px", fontWeight: "bold" }}>{setLabel("informacionContactoRepresentanteLegal")}</h2>}
                contenido={
                  <div className={config.theme === "Dark" ? "texto-blanco" : ""}>
                    <div className="inputsProveedorContainer">
                      {/* Nombre del representante legal */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.NombreRepresentanteLegal}
                            onChange={(e) =>handleInputChange(e, "NombreRepresentanteLegal")}
                            className={classNames({"p-invalid": showMessages?.NombreRepresentanteLegal})}
                            disabled={!editable}
                          />
                          <label>{setLabel("Nombre")}</label>
                        </div>
                      </div>

                      {/* Telefono del representante legal */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.TelefonoRepresentante}
                            onChange={(e) =>handleInputChange(e, "TelefonoRepresentante")}
                            className={classNames({ "p-invalid": showMessages?.TelefonoRepresentante,})}
                            disabled={!editable}
                          />
                          <label>{setLabel("TelefonoRef")}</label>
                        </div>
                      </div>

                      {/* Correo electrónico */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.CorreoRepresentante}
                            onChange={(e) =>handleInputChange(e, "CorreoRepresentante")}
                            className={classNames({"p-invalid": showMessages?.CorreoRepresentante,})}
                            disabled={!editable}
                          />
                          <label>{setLabel("Email")}</label>
                        </div>
                      </div>

                      {/* Identificacion */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.IdentificacionRepresentante}
                            onChange={(e) =>handleInputChange(e, "IdentificacionRepresentante")}
                            className={classNames({"p-invalid": showMessages?.IdentificacionRepresentante,})}
                            disabled={!editable}
                          />
                          <label>{setLabel("NumIdentificacionTributaria")}</label>
                        </div>
                      </div>
                    
                    </div>
                    {/* Archivo Representante */}
                    <div>
                      <label style={{ minHeight: 'auto', marginLeft: '12px' }}>
                      {setLabel("IdentificacionReg")}: 
                      </label>
                      <div style={{ minHeight: 'auto', marginLeft: '12px' }}>
                        <FileUpload
                          ref={fileUpload}
                          name="demo"
                          url="./upload"
                          customUpload
                          chooseLabel={setLabel("Cargar")}
                          uploadHandler={subirFileRepresentante}
                          required
                          auto
                          maxFileSize={5242880} //EQUIVALENTE A 5 MB
                          disabled={!editable}
                        />
                        {showMessages?.FileRepresentante && ( <small className="p-error"> {setLabel('AgregueArchivo')} </small> )}
                        <div className="mt-3 mb-3">
                          <div>
                            {listadoArchivoRepresentante?.map((a, i) => (
                              <div
                                className="d-flex gap p-2 border mt-2"
                                style={{ alignItems: "center" }}
                                key={i}
                              >
                                <div className="col-9">{a}</div>
                                <Button
                                  icon="pi pi-download"
                                  onClick={() => DescargarArchivoFun(a, "Representante")}
                                  disabled={!editable}
                                />
                                <Button
                                  icon="pi pi-trash"
                                  severity="danger"
                                  onClick={() => EliminarArchivoFun(a, "Representante")}
                                  disabled={!editable}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* MENSAJES DE ERROR */}
                    {showMessages.RepresentanteLegal && (
                      <div className="p-error">
                        {setLabel("completarCamposObligatorios")}
                      </div>
                    )}
                  </div>
                }
              />

              {/* SOCIOS DE EMPRESA */}
              {habilitarCredito &&(
                <Card
                  titulo={ <h2 style={{ fontSize: "18px", fontWeight: "bold" }}> {setLabel("Socios")} </h2> }
                  contenido={
                    <div className={config.theme === "Dark" ? "texto-blanco" : ""}>
                      {/* Inputs para agregar o editar un socio */}
                      <div className="inputsProveedorContainer">
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.NombreAccionista}
                              onChange={(e) => handleInputChange(e, "NombreAccionista")}
                              className={classNames({ "p-invalid": showMessages?.NombreAccionista, })}
                              disabled={!editable}
                            />
                            <label>{setLabel("Nombre")}</label>
                          </div>
                        </div>

                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.IdentificacionAccionista}
                              onChange={(e) =>handleInputChange(e, "IdentificacionAccionista")}
                              className={classNames({ "p-invalid": showMessages?.IdentificacionAccionista,})}
                              disabled={!editable}
                            />
                            <label>{setLabel("Identificacion")}</label>
                          </div>
                        </div>

                        <div>
                          <AutoCompleteDropdown
                            name={"Nacionalidad"}
                            value={values.Nacionalidad}
                            label={setLabel("Pais")}
                            items={Countries}
                            field={"Country"}
                            handleInputChange={handleInputChange}
                            className={classNames({
                              "p-invalid": showMessages?.Nacionalidad,
                            })}
                            enable={editable}
                          />
                        </div>

                        <div>
                          <div className="p-float-label">
                            <InputNumber
                              value={values?.PorcentajeParticipacion}
                              onChange={(e) => handleInputChange(e, "PorcentajeParticipacion")}
                              suffix=" %"
                              disabled={!editable}
                              style={{ width: "100%" }}
                            />
                            <label>{setLabel("Porcentaje")}</label>
                          </div>
                        </div>

                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.EmailAccionista}
                              onChange={(e) => handleInputChange(e, "EmailAccionista")}
                              className={classNames({"p-invalid": showMessages?.EmailAccionista,})}
                              disabled={!editable}
                            />
                            <label>{setLabel("Email")}</label>
                          </div>
                        </div>

                        <div className="mt-3">
                          <Button
                            icon="pi pi-plus"
                            type="button"
                            disabled={!editable}
                            tooltip={setLabel("Agregar Accionista")}
                            tooltipOptions={{position: "top"}}
                            onClick={agregarAccionista}
                          />
                        </div>
                      </div>

                      {/* Mensajes de error */}
                      {showMessages.ErrorAccionistas && (
                        <div className="p-error">
                          {setLabel("completarCamposObligatorios")}
                        </div>
                      )}

                        {/* Tabla de socios */}
                        <div 
                          style={{width: '50%'}}
                          className="mx-3 mb-3"
                        >
                          <div style={{ overflowX: "auto", overflowY: "auto", maxHeight: "250px"}}>
                            {listadoAccionistas?.length > 0 && (
                              <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                <thead style={{ backgroundColor: "#4CAF50", color: "black"}}>
                                  <tr>
                                    <th style={{ padding: "8px !important", border: "1px solid #ddd", width: "30%" }}>
                                      <div className="p-2">
                                      {setLabel("Nombre")}
                                      </div>
                                    </th>
                                    <th style={{ padding: "8px", border: "1px solid #ddd", width: "20%" }}>
                                      <div className="p-2">
                                        {setLabel("Identificacion")}
                                      </div>
                                    </th>
                                    <th style={{ padding: "8px", border: "1px solid #ddd", width: "15%" }}>
                                      <div className="p-2">
                                        {setLabel("Porcentaje")}
                                      </div>
                                    </th>
                                    <th style={{ padding: "8px", border: "1px solid #ddd", width: "20%" }}>
                                      <div className="p-2">
                                        {setLabel("Nacionalidad")}
                                      </div>
                                    </th>
                                    <th style={{ padding: "8px", border: "1px solid #ddd", width: "15%" }}>
                                      {/* {setLabel("Acciones")} */}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {listadoAccionistas.map((accionista, index) => (
                                    <tr key={index} style={{ borderBottom: "1px solid #ddd" }}>
                                      <td style={{ padding: "8px", border: "1px solid #ddd", width: "25%" }}>
                                        {accionista.NombreAccionista}
                                      </td>
                                      <td style={{ padding: "8px", border: "1px solid #ddd", width: "25%" }}>
                                        {accionista.IdentificacionAccionista}
                                      </td>
                                      <td style={{ padding: "8px", border: "1px solid #ddd", width: "15%", textAlign: "center" }}>
                                        {accionista.PorcentajeParticipacion}%
                                      </td>
                                      <td style={{ padding: "8px", border: "1px solid #ddd", width: "20%" }}>
                                        {accionista.Nacionalidad}
                                      </td>
                                      <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: "center", width: "15%" }}>
                                        <button 
                                          onClick={() => editarAccionista(accionista.Id)}
                                          disabled={!editable}
                                          style={{ backgroundColor: "transparent", border: "none", padding: "0", cursor: "pointer", marginRight: "10px" }}
                                        >
                                          <i className="pi pi-pencil"></i>
                                        </button>

                                        <button 
                                          onClick={() => eliminarAccionista(accionista.Id)}
                                          disabled={!editable}
                                          style={{ backgroundColor: "transparent", border: "none", padding: "0", cursor: "pointer" }}
                                        >
                                          <i className="pi pi-trash"></i>
                                        </button>
                                      </td>

                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            )}
                          </div>
                        </div>

                    </div>
                  }
                />
              )}

              {/* DIRECTORES DE EMPRESA */}
              {habilitarCredito && (
                <Card
                  titulo={ <h2 style={{ fontSize: "18px", fontWeight: "bold" }}> {setLabel("Directores")} </h2> }
                  contenido={
                    <div className={config.theme === "Dark" ? "texto-blanco" : ""}>
                      {/* Inputs */}
                      <div className="inputsProveedorContainer">
                        {/* Nombre Director */}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.NombreDirector}
                              onChange={(e) =>handleInputChange(e, "NombreDirector")}
                              className={classNames({"p-invalid": showMessages?.NombreDirector,})}
                              disabled={!editable}
                            />
                            <label>{setLabel("Nombre")}</label>
                          </div>
                        </div>

                        {/* Identificacion Director*/}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.IdentificacionDirector}
                              onChange={(e) =>handleInputChange(e, "IdentificacionDirector")}
                              className={classNames({"p-invalid": showMessages?.IdentificacionDirector,})}
                              disabled={!editable}
                            />
                            <label>{setLabel("Identificacion")}</label>
                          </div>
                        </div>

                        {/* PAIS */}
                        <div>
                          <AutoCompleteDropdown
                            name={"NacionalidadDirector"}
                            value={values.NacionalidadDirector}
                            label={setLabel("Pais")}
                            items={Countries}
                            field={"Country"}
                            handleInputChange={handleInputChange}
                            className={classNames({ "p-invalid": showMessages?.NacionalidadDirector })}
                            enable={editable}
                          />
                        </div>

                        {/* Identificacion Director*/}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.Posicion}
                              onChange={(e) =>handleInputChange(e, "Posicion")}
                              className={classNames({"p-invalid": showMessages?.Posicion,})}
                              disabled={!editable}
                            />
                            <label>{setLabel("Posición")}</label>
                          </div>
                        </div>

                        {/* Email */}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.EmailDirector}
                              onChange={(e) =>handleInputChange(e, "EmailDirector")}
                              className={classNames({"p-invalid": showMessages?.EmailDirector,})}
                              disabled={!editable}
                            />
                            <label>{setLabel("Email")}</label>
                          </div>
                        </div>

                        <div className="mt-3">
                          <Button
                            icon="pi pi-plus"
                            type="button"
                            disabled={!editable}
                            tooltip={setLabel("Agregar Director")}
                            tooltipOptions={{position: "top" }}
                            onClick={agregarDirectores}
                          />
                        </div>
                      </div>
                      {/* MENSAJES DE ERROR */}
                      {showMessages.ErrorDirectores && ( <div className="p-error"> {setLabel("completarCamposObligatorios")} </div> )}

                        {/* Lista de accionistas */}
                      <div
                        style={{width: '50%'}}
                        className="mx-3 mb-3"
                      >
                        <div style={{ overflowX: "auto", overflowY: "auto", maxHeight: "250px"}}>
                          {listadoDirectores?.length > 0 && (
                            <table style={{ borderCollapse: "collapse", width: "100%" }}>
                              <thead style={{ backgroundColor: "#4CAF50", color: "black" }}>
                                <tr>
                                  <th style={{ padding: "8px", border: "1px solid #ddd", width: "30%" }}>
                                    <div className="p-2">
                                      {setLabel("Nombre")}
                                    </div>
                                  </th>
                                  <th style={{ padding: "8px", border: "1px solid #ddd", width: "20%" }}>
                                    <div className="p-2">
                                      {setLabel("Identificacion")}
                                    </div>
                                  </th>
                                  <th style={{ padding: "8px", border: "1px solid #ddd", width: "15%" }}>
                                    <div className="p-2">
                                      {setLabel("Nacionalidad")}
                                    </div>
                                  </th>
                                  <th style={{ padding: "8px", border: "1px solid #ddd", width: "20%" }}>
                                    <div className="p-2">
                                      {setLabel("Posicion")} 
                                    </div>
                                  </th>
                                  <th style={{ padding: "8px", border: "1px solid #ddd", width: "15%" }}>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {listadoDirectores.map((director, index) => (
                                  <tr key={index} style={{ borderBottom: "1px solid #ddd" }}>
                                    <td style={{ padding: "8px", border: "1px solid #ddd", width: "25%" }}>
                                      {director.NombreDirector}
                                    </td>
                                    <td style={{ padding: "8px", border: "1px solid #ddd", width: "25%" }}>
                                      {director.IdentificacionDirector}
                                    </td>
                                    <td style={{ padding: "8px", border: "1px solid #ddd", width: "15%" }}>
                                      {director.NacionalidadDirector}
                                    </td>
                                    <td style={{ padding: "8px", border: "1px solid #ddd", width: "20%" }}>
                                      {director.Posicion}
                                    </td>
                                    <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: "center", width: "15%" }}>
                                      <button 
                                        onClick={() => editarDirector(director.Id)}
                                        disabled={!editable}
                                        style={{ backgroundColor: "transparent", border: "none", padding: "0", cursor: "pointer", marginRight: "10px" }}
                                      >
                                        <i className="pi pi-pencil"></i>
                                      </button>

                                      <button 
                                        onClick={() => eliminarDirector(director.Id)}
                                        disabled={!editable}
                                        style={{ backgroundColor: "transparent", border: "none", padding: "0", cursor: "pointer" }}
                                      >
                                        <i className="pi pi-trash"></i>
                                      </button>
                                    </td>

                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          )}
                        </div>
                      </div>
                    </div>
                  }
                />
              )}

              {/* INFORMACION DE CONTACTO CUENTAS POR PAGAR */}
              <Card
                titulo={ <h2 style={{ fontSize: "18px", fontWeight: "bold" }}> {setLabel("inforamcionContactoCuentasPagar")} </h2> }
                contenido={
                  <div>
                    <div className="inputsProveedorContainer">
                      {/* Contacto de cuentas por cobrar (Nombre) */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.ContactoCuentasPorPagar}
                            onChange={(e) =>handleInputChange(e, "ContactoCuentasPorPagar")}
                            className={classNames({"p-invalid": showMessages?.ContactoCuentasPorPagar,})}
                            disabled={!editable}
                          />
                          <label>{setLabel("Nombre")}</label>
                        </div>
                      </div>

                      {/* Correo electrónico (cuentas por cobrar) */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values?.CorreoCuentasPorPagar}
                            onChange={(e) =>handleInputChange(e, "CorreoCuentasPorPagar")}
                            className={classNames({"p-invalid": showMessages?.CorreoCuentasPorPagar,})}
                            disabled={!editable}
                          />
                          <label>{setLabel("Email")}</label>
                        </div>
                      </div>

                      {/* Número de teléfono */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.TelefonoCuentasPorPagar}
                            onChange={(e) =>handleInputChange(e, "TelefonoCuentasPorPagar")}
                            className={classNames({"p-invalid": showMessages?.TelefonoCuentasPorPagar,})}
                            disabled={!editable}
                          />
                          <label>{setLabel("numeroTelefono")}</label>
                        </div>
                      </div>
                    </div>
                    {/* MENSAJES DE ERROR */}
                    {showMessages.CuentasPorCobrar && ( <div className="p-error"> {setLabel("completarCamposObligatorios")} </div> )}
                  </div>
                }
              />

              {/* INFORMACION DE CONTACTO FINANZAS */}
              <Card
                titulo={<h2 style={{ fontSize: "18px", fontWeight: "bold" }}>{setLabel("inforamcionContactoFinanzas")}</h2>}
                contenido={
                  <div className={config.theme === "Dark" ? "texto-blanco" : ""}>
                    <div className="inputsProveedorContainer">
                      {/* Contacto de cuentas por cobrar (Nombre) */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.NombreContactoFin1}
                            onChange={(e) =>handleInputChange(e, "NombreContactoFin1")}
                            className={classNames({"p-invalid": showMessages?.NombreContactoFin1,})}
                            disabled={!editable}
                          />
                          <label>{setLabel("Nombre")}</label>
                        </div>
                      </div>

                      {/* Correo electrónico (cuentas por cobrar) */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.CorreoContactoFin1}
                            onChange={(e) =>handleInputChange(e, "CorreoContactoFin1")}
                            className={classNames({"p-invalid": showMessages?.CorreoContactoFin1,})}
                            disabled={!editable}
                          />
                          <label>{setLabel("Email")}</label>
                        </div>
                      </div>

                      {/* Número de teléfono */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.TelefonoContactoFin1}
                            onChange={(e) =>handleInputChange(e, "TelefonoContactoFin1")}
                            className={classNames({"p-invalid": showMessages?.TelefonoContactoFin1,})}
                            disabled={!editable}
                          />
                          <label>{setLabel("numeroTelefono")}</label>
                        </div>
                      </div>
                    </div>

                    {/* MENSAJES DE ERROR */}
                    {showMessages.ConcactoFinanzas && (<div className="p-error">{setLabel("completarCamposObligatorios")}</div>)}
                  </div>
                }
              />

              {/* REFERENCIAS COMERCIALES */}
              {habilitarCredito && (
                <Card
                  titulo={<h2 style={{ fontSize: "18px", fontWeight: "bold" }}>{setLabel("referenciasComerciales")}</h2>}
                  contenido={
                    <div className={config.theme === "Dark" ? "texto-blanco" : ""}>
                      {/* NOMBRE COMPAñIA 1 */}
                      <div className="seccionText">
                        <span>{setLabel("Referencia")} 1:</span>
                      </div>

                      <div className="inputsProveedorContainer">

                        {/* Nombre Compañía */}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.CompanyRefComercial1}
                              onChange={(e) => handleInputChange(e, "CompanyRefComercial1")}
                              className={classNames({"p-invalid": showMessages?.CompanyRefComercial1,})}
                              disabled={!editable}
                            />
                            <label>{setLabel("CompanyRefComercial")}</label>
                          </div>
                        </div>
                        {/* Nombre Contacto */}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.RefNombre1}
                              onChange={(e) => handleInputChange(e, "RefNombre1")}
                              className={classNames({"p-invalid": showMessages?.RefNombre1,})}
                              disabled={!editable}
                            />
                            <label>{setLabel("nombreContacto1")}</label>
                          </div>
                        </div>
                        {/* Telefono */}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.RefTelefono1}
                              onChange={(e) => handleInputChange(e, "RefTelefono1")}
                              className={classNames({"p-invalid": showMessages?.RefTelefono1,})}
                              disabled={!editable}
                            />
                            <label>{setLabel("numeroTelefono")}</label>
                          </div>
                        </div>
                        {/* Correo */}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.RefCorreo1}
                              onChange={(e) => handleInputChange(e, "RefCorreo1")}
                              className={classNames({"p-invalid": showMessages?.RefCorreo1,})}
                              disabled={!editable}
                            />
                            <label>{setLabel("Email")}</label>
                          </div>
                        </div>
                      </div>

                      {/* Archivo */}
                      <div>
                        <div style={{ minHeight: 'auto', marginLeft: '12px' }}>
                          <label for="formFile" className="form-label">
                            {setLabel("RefLoad")}: 
                          </label>
                        </div>
                        <div className="mb-3" style={{ minHeight: 'auto', marginLeft: '12px' }}>
                          <FileUpload
                            ref={fileUpload}
                            name="demo"
                            url="./upload"
                            customUpload
                            chooseLabel={setLabel("Cargar")}
                            uploadHandler={subirFileRefComercial1}
                            required
                            auto
                            maxFileSize={5242880} //EQUIVALENTE A 5 MB
                            disabled={!editable}
                          />
                          {showMessages?.FileRefComercial1 && (<small className="p-error"> {setLabel('AgregueArchivo')} </small>)}
                          <div className="mt-3">
                            <div>
                              {listadoArchivoRefComercial1?.map((a, i) => (
                                <div
                                  className="d-flex gap p-2 border mt-2"
                                  style={{ alignItems: "center" }}
                                  key={i}
                                >
                                  <div className="col-9">{a}</div>
                                  <Button
                                    icon="pi pi-download"
                                    onClick={() => DescargarArchivoFun(a, "RefComercial1")}
                                    disabled={!editable}
                                  />
                                  <Button
                                    icon="pi pi-trash"
                                    severity="danger"
                                    onClick={() => EliminarArchivoFun(a, "RefComercial1")}
                                    disabled={!editable}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    

                      <div className="seccionText">
                        <span>{setLabel("Referencia")} 2:</span>
                      </div>

                      <div className="inputsProveedorContainer">

                        {/* Nombre Compañía */}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.CompanyRefComercial2}
                              onChange={(e) => handleInputChange(e, "CompanyRefComercial2")}
                              className={classNames({"p-invalid": showMessages?.CompanyRefComercial2,})}
                              disabled={!editable}
                            />
                            <label>{setLabel("CompanyRefComercial")}</label>
                          </div>
                        </div>

                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.RefNombre2}
                              onChange={(e) => handleInputChange(e, "RefNombre2")}
                              className={classNames({"p-invalid": showMessages?.RefNombre2,})}
                              disabled={!editable}
                            />
                            <label>{setLabel("nombreContacto1")}</label>
                          </div>
                        </div>
                        {/* Telefono */}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.RefTelefono2}
                              onChange={(e) => handleInputChange(e, "RefTelefono2")}
                              className={classNames({"p-invalid": showMessages?.RefTelefono2,})}
                              disabled={!editable}
                            />
                            <label>{setLabel("numeroTelefono")}</label>
                          </div>
                        </div>
                        {/* Correo */}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.RefCorreo2}
                              onChange={(e) => handleInputChange(e, "RefCorreo2")}
                              className={classNames({"p-invalid": showMessages?.RefCorreo2, })}
                              disabled={!editable}
                            />
                            <label>{setLabel("Email")}</label>
                          </div>
                        </div>
                      </div>
                      {/* Archivo */}
                      <div>
                        <div>
                          <div>
                            <label for="formFile" className="form-label" style={{ minHeight: 'auto', marginLeft: '12px' }}>
                              {setLabel("RefLoad")}: 
                            </label>
                          </div>
                          <div className="mb-3" style={{ minHeight: 'auto', marginLeft: '12px' }}>
                            <FileUpload
                              ref={fileUpload}
                              name="demo"
                              url="./upload"
                              customUpload
                              chooseLabel={setLabel("Cargar")}
                              uploadHandler={subirFileRefComercial2}
                              required
                              auto
                              maxFileSize={5242880} //EQUIVALENTE A 5 MB
                              disabled={!editable}
                            />
                            {showMessages?.FileRefComercial2 && (<small className="p-error"> {setLabel('AgregueArchivo')} </small>)}
                            <div className="mt-3">
                              <div>
                                {listadoArchivoRefComercial2?.map((a, i) => (
                                  <div
                                    className="d-flex gap p-2 border mt-2"
                                    style={{ alignItems: "center" }}
                                    key={i}
                                  >
                                    <div className="col-9">{a}</div>
                                    <Button
                                      icon="pi pi-download"
                                      onClick={() => DescargarArchivoFun(a, "RefComercial2")}
                                      disabled={!editable}
                                    />
                                    <Button
                                      icon="pi pi-trash"
                                      severity="danger"
                                      onClick={() => EliminarArchivoFun(a, "RefComercial2")}
                                      disabled={!editable}
                                    />
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* MENSAJES DE ERROR */}
                      {showMessages.ReferenciasComerciales && ( <div className="p-error"> {setLabel("completarCamposObligatorios")} </div> )}
                    </div>
                  }
                />
              )}

              {/* REFERENCIAS BANCARIAS */}
              {habilitarCredito && (
                <Card
                  titulo={<h2 style={{ fontSize: "18px", fontWeight: "bold" }}>{setLabel("referenciasBancarias")}</h2>}
                  contenido={
                    <div className={config.theme === "Dark" ? "texto-blanco" : ""}>
                      {/* NOMBRE COMPAñIA 1 */}
                      <div className="seccionText">
                        <span>{setLabel("Referencia")} 1:</span>
                      </div>

                      <div className="inputsProveedorContainer">

                        {/* Nombre Banco */}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.BankName1}
                              onChange={(e) => handleInputChange(e, "BankName1")}
                              className={classNames({"p-invalid": showMessages?.BankName1})}
                              disabled={!editable}
                            />
                            <label>{setLabel("BankName")}</label>
                          </div>
                        </div>

                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.NombreRefBancaria1}
                              onChange={(e) => handleInputChange(e, "NombreRefBancaria1")}
                              className={classNames({"p-invalid": showMessages?.NombreRefBancaria1,})}
                              disabled={!editable}
                            />
                            <label>{setLabel("nombreContacto1")}</label>
                          </div>
                        </div>
                        {/* Telefono */}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.TelefonoRefBancaria1}
                              onChange={(e) => handleInputChange(e, "TelefonoRefBancaria1")}
                              className={classNames({"p-invalid": showMessages?.TelefonoRefBancaria1,})}
                              disabled={!editable}
                            />
                            <label>{setLabel("numeroTelefono")}</label>
                          </div>
                        </div>
                        {/* Correo */}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.CorreoRefBancaria1}
                              onChange={(e) => handleInputChange(e, "CorreoRefBancaria1")}
                              className={classNames({"p-invalid": showMessages?.CorreoRefBancaria1,})}
                              disabled={!editable}
                            />
                            <label>{setLabel("Email")}</label>
                          </div>
                        </div>
                      </div>

                      {/* Archivo Bancarias 1*/}
            
                      <div style={{ minHeight: 'auto', marginLeft: '12px' }}>
                        <div>
                        <label for="formFile" className="form-label">
                          {setLabel("RefLoad")}: 
                        </label>
                        </div>
                        {/* Archovo Ref Banc 1 */}
                        <div className="mb-3">
                          <FileUpload
                            ref={fileUpload}
                            chooseLabel={setLabel("Cargar")}
                            name="demo"
                            url="./upload"
                            customUpload
                            uploadHandler={subirFileRefBanc1}
                            required
                            auto
                            maxFileSize={5242880} 
                            disabled={!editable}
                          />
                          {showMessages?.FileRefBanc1 && (<small className="p-error"> {setLabel('AgregueArchivo')} </small>)}
                          <div className="mt-3">
                            <div>
                              {listadoArchivoRefBanc1?.map((a, i) => (
                                <div
                                  className="d-flex gap p-2 border mt-2"
                                  style={{ alignItems: "center" }}
                                  key={i}
                                >
                                  <div className="col-9">{a}</div>
                                  <Button
                                    icon="pi pi-download"
                                    onClick={() => DescargarArchivoFun(a, "RefBanc1")}
                                    disabled={!editable}
                                  />
                                  <Button
                                    icon="pi pi-trash"
                                    severity="danger"
                                    onClick={() => EliminarArchivoFun(a, "RefBanc1")}
                                    disabled={!editable}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>


                      <div className="seccionText">
                        <span>{setLabel("Referencia")} 2:</span>
                      </div>

                      <div className="inputsProveedorContainer">
                        {/* Nombre Banco */}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.BankName2}
                              onChange={(e) => handleInputChange(e, "BankName2")}
                              className={classNames({"p-invalid": showMessages?.BankName2,})}
                              disabled={!editable}
                            />
                            <label>{setLabel("BankName")}</label>
                          </div>
                        </div>

                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.NombreRefBancaria2}
                              onChange={(e) => handleInputChange(e, "NombreRefBancaria2")}
                              className={classNames({"p-invalid": showMessages?.NombreRefBancaria2,})}
                              disabled={!editable}
                            />
                            <label>{setLabel("nombreContacto1")}</label>
                          </div>
                        </div>
                        {/* Telefono */}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.TelefonoRefBancaria2}
                              onChange={(e) => handleInputChange(e, "TelefonoRefBancaria2")}
                              className={classNames({ "p-invalid": showMessages?.TelefonoRefBancaria2, })}
                              disabled={!editable}
                            />
                            <label>{setLabel("numeroTelefono")}</label>
                          </div>
                        </div>
                        {/* Correo */}
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values.CorreoRefBancaria2}
                              onChange={(e) => handleInputChange(e, "CorreoRefBancaria2")}
                              className={classNames({"p-invalid": showMessages?.CorreoRefBancaria2})}
                              disabled={!editable}
                            />
                            <label>{setLabel("Email")}</label>
                          </div>
                        </div>
                      </div>

                      {/* Archivo Bancarias 2*/}
          
                      <div style={{ minHeight: 'auto', marginLeft: '12px' }}>
                        <div>
                        <label for="formFile" className="form-label">
                        {setLabel("RefLoad")}: 
                        </label>
                        </div>
                        <div className="mb-3">
                          <FileUpload
                            ref={fileUpload}
                            name="demo"
                            chooseLabel={setLabel("Cargar")}
                            url="./upload"
                            customUpload
                            uploadHandler={subirFileRefBanc2}
                            required
                            auto
                            maxFileSize={5242880} //EQUIVALENTE A 5 MB
                            disabled={!editable}
                          />
                          {showMessages?.FileRefBanc2 && (<small className="p-error"> {setLabel('AgregueArchivo')} </small>)}
                          <div className="mt-3">
                            <div>
                              {listadoArchivoRefBanc2?.map((a, i) => (
                                <div
                                  className="d-flex gap p-2 border mt-2"
                                  style={{ alignItems: "center" }}
                                  key={i}
                                >
                                  <div className="col-9">{a}</div>
                                  <Button
                                    icon="pi pi-download"
                                    onClick={() => DescargarArchivoFun(a, "RefBanc2")}
                                    disabled={!editable}
                                  />
                                  <Button
                                    icon="pi pi-trash"
                                    severity="danger"
                                    onClick={() => EliminarArchivoFun(a, "RefBanc2")}
                                    disabled={!editable}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    

                      {/* MENSAJES DE ERROR */}
                      {showMessages.ReferenciasComerciales && (<div className="p-error">{setLabel("completarCamposObligatorios")}</div>)}
                    </div>
                  }
                />
              )}

              {/* DOCUMENTACION */}
              <Card
                titulo={<h2 style={{ fontSize: "18px", fontWeight: "bold" }}>{setLabel("Documentation")}</h2>}
                contenido={
                  <div className={config.theme === "Dark" ? "texto-blanco" : ""} style={{ minHeight: 'auto', marginLeft: '12px' }}>
                    <div className="seccionText">
                      <span>{setLabel("adjuntarDocumentos")}</span>
                    </div>
                    <div className="">

                      {/* BIC */}
                      <div>
                        <div>
                          <div>
                          <label for="formFile" className="form-label">
                            <strong >BIC:</strong> RTN/NIT/RUC/TAX ID
                          </label>
                          </div>
                          <div className="mb-3">
                            <FileUpload
                              ref={fileUpload}
                              name="demo"
                              url="./upload"
                              chooseLabel={setLabel("Cargar")}
                              customUpload
                              uploadHandler={subirFileBIC}
                              required
                              auto
                              maxFileSize={5242880} //EQUIVALENTE A 5 MB
                              disabled={!editable}
                            />
                            {showMessages?.FileBIC && (<small className="p-error"> {setLabel('AgregueArchivo')} </small>)}
                            <div className="mt-3">
                              <div>
                                {listadoArchivos?.map((a, i) => (
                                  <div
                                    className="d-flex gap p-2 border mt-2"
                                    style={{ alignItems: "center" }}
                                    key={i}
                                  >
                                    <div className="col-9">{a}</div>
                                    <Button
                                      icon="pi pi-download"
                                      onClick={() => DescargarArchivoFun(a, "BIC")}
                                      disabled={!editable}
                                    />
                                    <Button
                                      icon="pi pi-trash"
                                      severity="danger"
                                      onClick={() => EliminarArchivoFun(a, "BIC")}
                                      disabled={!editable}
                                    />
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* FACTURA */}
                      {habilitarCredito && (
                        <div className="mb-3">
                          <div>
                            <label for="formFile" className="form-label">
                              <strong>{setLabel("Factura")}:</strong>
                            </label>
                          </div>
                          <FileUpload
                            ref={fileUpload}
                            name="demo"
                            url="./upload"
                            chooseLabel={setLabel("Cargar")}
                            multiple
                            customUpload
                            uploadHandler={subirFileFactura}
                            required
                            auto
                            maxFileSize={5242880} //EQUIVALENTE A 5 MB
                            disabled={!editable}
                          />
                          {showMessages?.FileFactura && (<small className="p-error"> {setLabel('AgregueArchivo')} </small>)}
                          <div>
                            {listadoArchivosFactura?.map((a, i) => (
                              <div
                                className="d-flex gap p-2 border mt-2"
                                style={{ alignItems: "center" }}
                                key={i}
                              >
                                <div className="col-9">{a}</div>
                                <Button
                                  icon="pi pi-download"
                                  onClick={() => DescargarArchivoFun(a, "Factura")}
                                  disabled={!editable}
                                />
                                <Button
                                  icon="pi pi-trash"
                                  severity="danger"
                                  onClick={() => EliminarArchivoFun(a, "Factura")}
                                  disabled={!editable}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      {/* ESTADOS FINANCIEROS */}
                      {habilitarCredito && (
                        <div className="mb-3">
                          <label for="formFile" className="form-label">
                            <strong>{setLabel("EstadoF")}:</strong>
                          </label>
                          <FileUpload
                            ref={fileUpload}
                            name="demo"
                            chooseLabel={setLabel("Cargar")}
                            url="./upload"
                            multiple
                            customUpload
                            uploadHandler={subirFileEstadosFin}
                            required
                            auto
                            maxFileSize={5242880} 
                            disabled={!editable}
                          />
                          {showMessages?.FileEstadosFinancieros && (<small className="p-error"> {setLabel('AgregueArchivo')} </small>)}

                          <div>
                            {listadoArchivosEstados?.map((a, i) => (
                              <div
                                className="d-flex gap p-2 border mt-2"
                                style={{ alignItems: "center" }}
                                key={i}
                              >
                                <div className="col-9">{a}</div>
                                <Button
                                  icon="pi pi-download"
                                  onClick={() => DescargarArchivoFun(a, "EstadosFin")}
                                  disabled={!editable}
                                />
                                <Button
                                  icon="pi pi-trash"
                                  severity="danger"
                                  onClick={() => EliminarArchivoFun(a, "EstadosFin")}
                                  disabled={!editable}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      {/* PERMISO DE OPERACIONES */}
                      <div>
                        <div>
                          <div className="mb-3">
                            <label for="formFile" className="form-label">
                              <strong>{setLabel("PermisoOperaciones")}:</strong>
                            </label>
                            <FileUpload
                              ref={fileUpload}
                              name="demo"
                              url="./upload"
                              multiple
                              chooseLabel={setLabel("Cargar")}
                              customUpload
                              uploadHandler={subirFilePermiso}
                              className={classNames( "form-control p-inputtext p-component",{ "p-invalid": showMessages?.FilePermisoOpera, } )}
                              auto
                              maxFileSize={5242880} //EQUIVALENTE A 5 MB
                              disabled={!editable}
                            />
                            {showMessages?.FilePermisoOpera && (<small className="p-error"> {setLabel('AgregueArchivo')} </small>)}
                            <div>
                              {listadoArchivosPermiso?.map((a, i) => (
                                <div
                                  className="d-flex gap p-2 border mt-2"
                                  style={{ alignItems: "center" }}
                                  key={i}
                                >
                                  <div className="col-9">{a}</div>
                                  <Button
                                    icon="pi pi-download"
                                    onClick={() => DescargarArchivoFun(a, "Permiso")}
                                    disabled={!editable}
                                  />
                                  <Button
                                    icon="pi pi-trash"
                                    severity="danger"
                                    onClick={() => EliminarArchivoFun(a, "Permiso")}
                                    disabled={!editable}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      {/* Escritura Constitucion */}
                      {habilitarCredito && (
                        <div>
                          <div>
                            <div className="mb-3">
                              <label for="formFile" className="form-label">
                                <strong>
                                  {setLabel("escrituraConstitucion")}:
                                </strong>
                              </label>
                              <FileUpload
                                ref={fileUpload}
                                name="demo"
                                url="./upload"
                                multiple
                                chooseLabel={setLabel("Cargar")}
                                customUpload
                                uploadHandler={subirFileEscritura}
                                className={classNames("form-control p-inputtext p-component",{"p-invalid": showMessages?.FileConstitucion,})}
                                required
                                auto
                                maxFileSize={5242880} 
                                disabled={!editable}
                              />
                              {showMessages?.FileConstitucion && (<small className="p-error"> {setLabel('AgregueArchivo')} </small>)}

                              {listadoArchivosEscritura?.map((a, i) => (
                                <div
                                  className="d-flex gap p-2 border mt-2"
                                  style={{ alignItems: "center" }}
                                  key={i}
                                >
                                  <div className="col-9">{a}</div>
                                  <Button
                                    icon="pi pi-download"
                                    onClick={() => DescargarArchivoFun(a, "Escritura")}
                                    disabled={!editable}
                                  />
                                  <Button
                                    icon="pi pi-trash"
                                    severity="danger"
                                    onClick={() => EliminarArchivoFun(a, "Escritura")}
                                    disabled={!editable}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      )}

                      {/* CUMPLIMIENTO AMBIENTAL */}
                      {habilitarCredito &&(
                        <div className="mb-3">
                          <div>
                            <label for="formFile" className="form-label">
                              <strong>{setLabel("CertificadoAmbiental")}:</strong>
                            </label>
                          </div>
                          <FileUpload
                            ref={fileUpload}
                            name="demo"
                            url="./upload"
                            multiple
                            chooseLabel={setLabel("Cargar")}
                            customUpload
                            uploadHandler={subirFileCertificadoA}
                            required
                            auto
                            maxFileSize={5242880}
                            disabled={!editable}
                          />
                          {showMessages?.FileCertificadoAmbiental && (<small className="p-error"> {setLabel('AgregueArchivo')} </small>)}
                          <div>
                            {listadoArchivoCertificadoA?.map((a, i) => (
                              <div
                                className="d-flex gap p-2 border mt-2"
                                style={{ alignItems: "center" }}
                                key={i}
                              >
                                <div className="col-9">{a}</div>
                                <Button
                                  icon="pi pi-download"
                                  onClick={() => DescargarArchivoFun(a, "CertificadoA")}
                                  disabled={!editable}
                                />
                                <Button
                                  icon="pi pi-trash"
                                  severity="danger"
                                  onClick={() => EliminarArchivoFun(a, "CertificadoA")}
                                  disabled={!editable}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      {/* CUMPLIMIENTO AMBIENTAL */}
                      {habilitarCredito &&(
                        <div className="mb-3">
                          <div>
                          <label for="formFile" className="form-label">
                            <strong>{setLabel("CertificadoLaboral")}:</strong>
                          </label>
                          </div>
                          <FileUpload
                            ref={fileUpload}
                            chooseLabel={setLabel("Cargar")}
                            name="demo"
                            url="./upload"
                            multiple
                            customUpload
                            uploadHandler={subirFileCertificadoL}
                            required
                            auto
                            maxFileSize={5242880} //EQUIVALENTE A 5 MB
                            disabled={!editable}
                          />
                          {showMessages?.FileCertificadoLaboral && (<small className="p-error"> {setLabel('AgregueArchivo')} </small>)}
                          <div>
                            {listadoArchivoCertificadoL?.map((a, i) => (
                              <div
                                className="d-flex gap p-2 border mt-2"
                                style={{ alignItems: "center" }}
                                key={i}
                              >
                                <div className="col-9">{a}</div>
                                <Button
                                  icon="pi pi-download"
                                  onClick={() => DescargarArchivoFun(a,"CertificadoL")}
                                  disabled={!editable}
                                />
                                <Button
                                  icon="pi pi-trash"
                                  severity="danger"
                                  onClick={() => EliminarArchivoFun(a,"CertificadoL")}
                                  disabled={!editable}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      
                      {/* ARCHIVO NACIONAL */}
                      {values?.Country?.IdCountry === IdHonduras && (
                        <div>
                          <div className="d-flex align-items-center mb-2">
                            <label className="mx-3" htmlFor="FileNacional">
                              <strong>{setLabel("zonaLibre")}:</strong>
                            </label>
                            <label
                              className={classNames("mx-3", {"fw-bold": ArchivoSelected === 0,})}
                              htmlFor="FileNacional"
                            >
                              {setLabel("no")}
                            </label>
                            <InputSwitch
                              checked={ArchivoSelected === 1}
                              onChange={() => {
                                ArchivoSelected === 1
                                  ? setArchivoSelected(0)
                                  : setArchivoSelected(1);

                                  verificarCampos(false, false, true)
                              }}
                              disabled={!editable}
                            />
                            <label
                              className={classNames("mx-3", {"fw-bold": ArchivoSelected === 1,})}
                              htmlFor="FileNacional"
                            >
                              {setLabel("si")}
                            </label>
                          </div>

                          {ArchivoSelected === 1 && (
                            <div className="inputsProveedorContainer">
                              {/* NOMBRE ZONA */}
                              <div>
                                <div className="p-float-label">
                                  <InputText
                                    value={values.NombreZonaLibre}
                                    onChange={(e) => handleInputChange(e, "NombreZonaLibre")}
                                    className={classNames({"p-invalid":showMessages?.NombreZonaLibre,})}
                                    disabled={!editable}
                                  />
                                  <label>{setLabel("nombreZona")}</label>
                                </div>
                              </div>

                              {/* DIRECCION ZONA */}
                              <div>
                                <div className="p-float-label">
                                  <InputText
                                    value={values.DireccionZonaLibre}
                                    onChange={(e) =>handleInputChange(e, "DireccionZonaLibre")}
                                    className={classNames({ "p-invalid": showMessages?.DireccionZonaLibre, })}
                                    disabled={!editable}
                                  />
                                  <label>{setLabel("direccionZona")}</label>
                                </div>
                              </div>
                            </div>
                          )}

                          <div>
                            {ArchivoSelected === 0 ? (
                              null
                            ) : (
                              <div className="mb-3">
                                <label for="formFile" className="form-label">
                                  <strong>
                                    {setLabel("registroExonerado")}:
                                  </strong>
                                </label>
                                <FileUpload
                                  ref={fileUpload}
                                  chooseLabel={setLabel("Cargar")}
                                  name="demo"
                                  url="./upload"
                                  multiple
                                  customUpload
                                  className={classNames("form-control p-inputtext p-component", { "p-invalid": showMessages?.FileRegistroExonerado, } )}
                                  required
                                  auto
                                  maxFileSize={5242880}
                                  uploadHandler={subirFileRegistro}
                                  disabled={!editable}
                                />
                                {showMessages?.FileRegistroExonerado && (<small className="p-error"> {setLabel('AgregueArchivo')} </small>)}

                                {listadoArchivosRegistro?.map((a, i) => (
                                  <div
                                    className="d-flex gap p-2 border mt-2"
                                    style={{ alignItems: "center" }}
                                    key={i}
                                  >
                                    <div className="col-9">{a}</div>
                                    <Button
                                      icon="pi pi-download"
                                      onClick={() => DescargarArchivoFun(a,"Registro")}
                                      disabled={!editable}
                                    />
                                    <Button
                                      icon="pi pi-trash"
                                      severity="danger"
                                      onClick={() => EliminarArchivoFun(a,"Registro")}
                                      disabled={!editable}
                                    />
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      )}

                    </div>

                    {/* MENSAJES DE ERROR */}
                    {showMessages.Documentos && (<div className="p-error">{setLabel("ErrorArchivoTamaño")}</div>)}
                  </div>
                  
                }
              />

              {/* AUTORIZACION */}
              <div className={config.theme === "Dark" ? "texto-blanco m-4" : "m-4"}>
                <div>
                  <div className='d-flex align-items-center mb-3'>
                    <Checkbox
                      required={true}
                      checked={values.Autorizacion}
                      onChange={(e) => handleInputChange(e, 'Autorizacion')}
                      className={classNames('mx-3', { 'p-invalid': showMessages?.Autorizacion })}
                      disabled={!editable}
                    />
                    <span>
                      {setLabel('autorizacionPagos')}
                    </span>
                  </div>
                  {/* MENSAJES DE ERROR */}
                  {showMessages.Autorizacion && <div className="p-error">{setLabel('completarCamposObligatorios')}</div>}

                </div>
                <br />

                <div style={{ marginLeft: 45 }} className='d-flex footerContainer '>
                  <span>{setLabel('infCierta')}</span>
                </div>

              </div>

              <div className="d-flex justify-content-center footerContainer position-relative">
                
                {/* CONTENEDOR DE BOTONES CENTRADOS */}
                <div className="botonesContainer">
                  <Button
                    className="m-2 p-button-success"
                    label={setLabel('guardarBorrador')}
                    icon="pi pi-save"
                    onClick={() => {
                      setValidar(true);
                      verificarCampos(true);
                    }}
                    disabled={!editable || !showMessages?.error}
                  />
                  <Button
                    className="m-2 p-button-success"
                    label={setLabel('guardar')}
                    icon="pi pi-save"
                    onClick={() => {
                      setValidar(true);
                      verificarCampos(true);
                    }}
                    disabled={!editable || showMessages?.error}
                  />
                  <Button
                    className="m-2 p-button-info"
                    label={setLabel('Imprimir')}
                    icon="pi pi-print"
                    onClick={(event) => {
                      let language = idioma === 'es' ? 2 : 1;
                      window.open(`${process.env.REACT_APP_URL}${process.env.REACT_APP_ENV}/FormatoInscripcionClientes/${values?.IdCustomer}/${Token}/2`,values?.IdCustomer,  "MsgWindow","height=1200,width=1000",)

                    }}
                    disabled={editable}
                  />
                </div>

                {/* FORMATO DE INSCRIPCIÓN ALINEADO A LA DERECHA */}
                {
                  !editable && (
                    <div style={{ minHeight: 'auto', width: '30%' }} className={config.theme === "Dark" ? "texto-blanco" : ""}>
                      <label htmlFor="formFile" className="form-label">
                        {setLabel("Formato de inscripción")}: 
                      </label>
                      <FileUpload
                        ref={fileUpload}
                        name="demo"
                        url="./upload"
                        customUpload
                        uploadHandler={subirFileFormatoIns}
                        required
                        maxFileSize={5242880}
                        disabled={editable}
                        style={{ width: '100%' }}
                        chooseLabel={setLabel("Cargar")}
                        uploadLabel={setLabel("Enviar")}
                        cancelLabel={setLabel("Cancelar")}
                      />
                      {showMessages?.FileFormatoInscripcion && (<small className="p-error"> {setLabel('AgregueArchivo')} </small>)}

                      <div className="mt-3">
                        {listadoArchivoFormatoInscripcion?.map((a, i) => (
                          <div
                            className="d-flex gap p-2 border mt-2"
                            style={{ alignItems: "center" }}
                            key={i}
                          >
                            <div className="col-9">{a}</div>
                            <Button
                              icon="pi pi-download"
                              onClick={() => DescargarArchivoFun(a,"FormatoIns")}
                              disabled={editable}
                            />
                            <Button
                              icon="pi pi-trash"
                              severity="danger"
                              onClick={() => EliminarArchivoFun(a,"FormatoIns")}
                              disabled={editable}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  )
                }
              </div>

            </div>

          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <h1>{setLabel('noPermiso')}</h1>
      </div>
    )
  }
};

export default InscripcionClientes;
